export const blueCheckmark = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill="#E0F2FE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2464 6.15838L8.27969 11.9167L6.69635 10.2251C6.40469 9.95005 5.94635 9.93339 5.61302 10.1667C5.28802 10.4084 5.19635 10.8334 5.39635 11.1751L7.27135 14.2251C7.45469 14.5084 7.77135 14.6834 8.12969 14.6834C8.47135 14.6834 8.79635 14.5084 8.97969 14.2251C9.27969 13.8334 15.0047 7.00838 15.0047 7.00838C15.7547 6.24172 14.8464 5.56672 14.2464 6.15005V6.15838Z"
      fill="#0494FE"
    />
  </svg>
);

export const cubeIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.60938 6.65358L9.74169 2.64166C9.87584 2.56621 9.94288 2.5285 10.0139 2.51371C10.0769 2.50064 10.1418 2.50064 10.2048 2.51371C10.2759 2.5285 10.3429 2.56621 10.4771 2.64166L17.6094 6.65358M2.60938 6.65358V14.6524C2.60938 14.8122 2.60938 14.892 2.6328 14.9633C2.65354 15.0264 2.68743 15.0843 2.73224 15.1333C2.78291 15.1887 2.8525 15.2279 2.99168 15.3061L10.1094 19.3098M2.60938 6.65358L10.1094 10.4036M17.6094 6.65358V14.6524C17.6094 14.8122 17.6094 14.892 17.5859 14.9633C17.5652 15.0264 17.5313 15.0843 17.4865 15.1333C17.4358 15.1887 17.3663 15.2279 17.2271 15.3061L10.1094 19.3098M17.6094 6.65358L10.1094 10.4036M10.1094 19.3098V10.4036"
      stroke="currentColor"
      strokeWidth="1.36364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const infoIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.1107 14.2082V10.8748M10.1107 7.5415H10.119M18.444 10.8748C18.444 15.4772 14.713 19.2082 10.1107 19.2082C5.5083 19.2082 1.77734 15.4772 1.77734 10.8748C1.77734 6.27246 5.5083 2.5415 10.1107 2.5415C14.713 2.5415 18.444 6.27246 18.444 10.8748Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const percentCircleIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1094 2.125C5.28 2.125 1.35938 6.04562 1.35938 10.875C1.35938 15.7044 5.28 19.625 10.1094 19.625C14.9387 19.625 18.8594 15.7044 18.8594 10.875C18.8594 6.04562 14.9387 2.125 10.1094 2.125ZM10.1094 3.375C14.2487 3.375 17.6094 6.73562 17.6094 10.875C17.6094 15.0144 14.2487 18.375 10.1094 18.375C5.97 18.375 2.60937 15.0144 2.60937 10.875C2.60937 6.73562 5.97 3.375 10.1094 3.375ZM12.8319 12.145C13.5106 12.2681 13.9625 12.9187 13.8394 13.5975C13.7162 14.2762 13.0656 14.7281 12.3869 14.605C11.7081 14.4819 11.2562 13.8312 11.3794 13.1525C11.5025 12.4737 12.1531 12.0219 12.8319 12.145ZM12.7925 7.30812L6.5425 13.5581C6.29875 13.8019 6.29875 14.1981 6.5425 14.4419C6.78625 14.6856 7.1825 14.6856 7.42625 14.4419L13.6762 8.19187C13.92 7.94812 13.92 7.55187 13.6762 7.30812C13.4325 7.06437 13.0362 7.06437 12.7925 7.30812ZM7.83188 7.145C8.51063 7.26813 8.9625 7.91875 8.83938 8.5975C8.71625 9.27625 8.06562 9.72812 7.38687 9.605C6.70812 9.48187 6.25625 8.83125 6.37937 8.1525C6.5025 7.47375 7.15313 7.02187 7.83188 7.145Z"
      fill="currentColor"
    />
  </svg>
);

export const israelFlagIcon = (
  <svg width="35" height="26" viewBox="0 0 35 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.5096 22.5074H3.49012C3.2138 22.5074 2.98975 22.2834 2.98975 22.007V3.99451C2.98975 3.7182 3.2138 3.49414 3.49012 3.49414H31.5096C31.7859 3.49414 32.01 3.7182 32.01 3.99451V22.007C32.0099 22.2834 31.7859 22.5074 31.5096 22.5074Z"
      fill="currentColor"
    />
    <path d="M32.0099 6.99668H2.98975V19.0049H32.0099V6.99668Z" fill="#F5F5F5" />
    <path
      d="M20.0996 13.0008L21.3995 10.7494H18.7998L17.4998 8.49768L16.1998 10.7494H13.6001L14.9 13.0008L13.6001 15.2522H16.1998L17.4998 17.5039L18.7998 15.2522H21.3994L20.0996 13.0008ZM20.1242 11.4857L19.6745 12.2645L19.2249 11.4857H20.1242ZM19.2494 13.0008L18.3747 14.5159H16.6248L15.7501 13.0008L16.6249 11.4857H18.3747L19.2494 13.0008ZM17.4998 9.97034L17.9496 10.7495H17.05L17.4998 9.97034ZM14.8754 11.4857H15.7746L15.325 12.2645L14.8754 11.4857ZM14.8754 14.5159L15.325 13.7371L15.7747 14.5159H14.8754ZM17.4998 16.0313L17.05 15.2521H17.9496L17.4998 16.0313ZM19.6745 13.7371L20.1242 14.5159H19.2249L19.6745 13.7371Z"
      fill="currentColor"
    />
  </svg>
);

export const chevronLeftIcon = (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1668 19.1109L10.0557 12.9998L16.1668 6.88867"
      stroke="currentColor"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronRightIcon = (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.8332 6.88867L15.9443 12.9998L9.8332 19.1109"
      stroke="currentColor"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const balconyIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.89873 7.21484H4.625V11.208H8.89873V7.21484Z" fill="#101828" />
    <path
      d="M4.71094 5.65504H8.91417V1.50586C6.77177 1.83806 5.07047 3.52166 4.71094 5.65504Z"
      fill="#101828"
    />
    <path
      d="M10.4531 1.50586V5.65508H14.6564C14.2968 3.52166 12.5955 1.83806 10.4531 1.50586Z"
      fill="#101828"
    />
    <path d="M14.7308 7.21484H10.457V11.208H14.7308V7.21484Z" fill="#101828" />
    <path
      d="M2.73134 14.7207V13.1234H16.308V14.7207H2.73134Z"
      stroke="#101828"
      strokeWidth="0.798627"
    />
  </svg>
);

export const floorplanIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 3.5H7C5.34315 3.5 4 4.84315 4 6.5V17.5C4 19.1569 5.34315 20.5 7 20.5H18C19.6569 20.5 21 19.1569 21 17.5V6.5C21 4.84315 19.6569 3.5 18 3.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11.5V3.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9.5L4 9.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 15.5L14 15.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 20.5V14.5H6"
      stroke="#currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const slidersIcon = (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9961_352689)">
      <path
        d="M15.75 15.5L10.5 15.5M7.5 15.5L2.25 15.5M15.75 9.5L9 9.5M6 9.5L2.25 9.5M15.75 3.5L12 3.5M9 3.5L2.25 3.5M10.5 17.75L10.5 13.25M6 11.75L6 7.25M12 5.75L12 1.25"
        stroke="#101828"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9961_352689">
        <rect width="18" height="18" fill="white" transform="translate(0 18.5) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
);

export const detailsIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 18L12.5 6M6.5 21L6.5 3M18.5 15L18.5 9"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const heartIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8227_287741)">
      <path
        d="M17.3558 4.02651C16.9479 3.61841 16.4636 3.29468 15.9305 3.07381C15.3974 2.85294 14.8261 2.73926 14.2491 2.73926C13.6721 2.73926 13.1008 2.85294 12.5677 3.07381C12.0347 3.29468 11.5504 3.61841 11.1424 4.02651L10.2959 4.87305L9.44936 4.02651C8.62542 3.20257 7.50792 2.73968 6.3427 2.73968C5.17748 2.73968 4.05998 3.20257 3.23604 4.02651C2.4121 4.85044 1.94922 5.96794 1.94922 7.13316C1.94922 8.29839 2.4121 9.41589 3.23604 10.2398L4.08258 11.0864L10.2959 17.2997L16.5092 11.0864L17.3558 10.2398C17.7639 9.83192 18.0876 9.34761 18.3085 8.81456C18.5293 8.28151 18.643 7.71016 18.643 7.13316C18.643 6.55617 18.5293 5.98482 18.3085 5.45177C18.0876 4.91872 17.7639 4.43441 17.3558 4.02651V4.02651Z"
        stroke="#101828"
        strokeWidth="1.2778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8227_287741">
        <rect
          width="19.167"
          height="19.167"
          fill="white"
          transform="translate(0.714844 0.344727)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const heartIconFilled = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8227_287741)">
      <path
        d="M17.3558 4.02651C16.9479 3.61841 16.4636 3.29468 15.9305 3.07381C15.3974 2.85294 14.8261 2.73926 14.2491 2.73926C13.6721 2.73926 13.1008 2.85294 12.5677 3.07381C12.0347 3.29468 11.5504 3.61841 11.1424 4.02651L10.2959 4.87305L9.44936 4.02651C8.62542 3.20257 7.50792 2.73968 6.3427 2.73968C5.17748 2.73968 4.05998 3.20257 3.23604 4.02651C2.4121 4.85044 1.94922 5.96794 1.94922 7.13316C1.94922 8.29839 2.4121 9.41589 3.23604 10.2398L4.08258 11.0864L10.2959 17.2997L16.5092 11.0864L17.3558 10.2398C17.7639 9.83192 18.0876 9.34761 18.3085 8.81456C18.5293 8.28151 18.643 7.71016 18.643 7.13316C18.643 6.55617 18.5293 5.98482 18.3085 5.45177C18.0876 4.91872 17.7639 4.43441 17.3558 4.02651V4.02651Z"
        stroke="#101828"
        strokeWidth="1.2778"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#F04438"
      />
    </g>
    <defs>
      <clipPath id="clip0_8227_287741">
        <rect
          width="19.167"
          height="19.167"
          fill="white"
          transform="translate(0.714844 0.344727)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const hashIcon = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.17188 7.53248H16.9499M4.17188 12.3242H16.9499M8.96364 2.74072L7.36638 17.116M13.7554 2.74072L12.1581 17.116"
      stroke="#101828"
      strokeWidth="1.2778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const doorIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.63281 17.1162L11.4177 17.1161V5.12813C11.4177 4.03877 11.4177 3.49409 11.1931 3.11656C10.996 2.78554 10.686 2.53685 10.3202 2.41635C9.90287 2.27891 9.37115 2.39707 8.3077 2.63338L6.23128 3.09481C5.51721 3.25349 5.16018 3.33284 4.89367 3.52483C4.65859 3.69419 4.47401 3.9243 4.35968 4.19051C4.23007 4.49233 4.23007 4.85807 4.23007 5.58956V17.1162M11.4129 4.33816H12.8552C13.7498 4.33816 14.1971 4.33816 14.5387 4.51224C14.8393 4.66538 15.0836 4.90972 15.2367 5.21027C15.4108 5.55194 15.4108 5.99921 15.4108 6.89376V17.1162H17.0081M9.02183 9.92857H9.02982"
      stroke="#101828"
      strokeWidth="1.2778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const squareMetersIcon = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0406 17.9281H6.29044C4.94862 17.9281 4.27771 17.9281 3.76521 17.667C3.31439 17.4373 2.94787 17.0708 2.71817 16.62C2.45703 16.1074 2.45703 15.4365 2.45703 14.0947V8.34458M8.84605 1.95557H12.0406M18.4296 8.34458V11.5391M15.2351 17.9281C15.9778 17.9281 16.3491 17.9281 16.6538 17.8465C17.4806 17.6249 18.1264 16.9791 18.348 16.1524C18.4296 15.8477 18.4296 15.4763 18.4296 14.7336M18.4296 5.15007C18.4296 4.40738 18.4296 4.03602 18.348 3.73135C18.1264 2.90455 17.4806 2.25874 16.6538 2.0372C16.3491 1.95557 15.9778 1.95557 15.2351 1.95557M5.65154 1.95557C4.90884 1.95557 4.53749 1.95557 4.23281 2.0372C3.40602 2.25874 2.76021 2.90455 2.53867 3.73135C2.45703 4.03602 2.45703 4.40738 2.45703 5.15007"
      stroke="#101828"
      strokeWidth="1.2778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.44922 12.287V7.99441H7.41616V8.72381H7.46647C7.5559 8.47788 7.70401 8.28598 7.91082 8.14811C8.11762 8.00838 8.36448 7.93852 8.6514 7.93852C8.94204 7.93852 9.18704 8.00931 9.38639 8.15091C9.5876 8.29064 9.7292 8.48161 9.81117 8.72381H9.85589C9.95091 8.48533 10.1111 8.2953 10.3366 8.1537C10.5639 8.01024 10.8331 7.93852 11.1442 7.93852C11.5392 7.93852 11.8615 8.06334 12.1112 8.313C12.3608 8.56265 12.4856 8.92689 12.4856 9.4057V12.287H11.4712V9.5622C11.4712 9.29578 11.4004 9.10109 11.2588 8.97812C11.1172 8.85329 10.9439 8.79088 10.739 8.79088C10.4949 8.79088 10.304 8.86727 10.1661 9.02004C10.0301 9.17095 9.96208 9.36751 9.96208 9.60971V12.287H8.96999V9.52028C8.96999 9.29857 8.90291 9.12158 8.76877 8.9893C8.63649 8.85702 8.46322 8.79088 8.24897 8.79088C8.10365 8.79088 7.97137 8.82814 7.85213 8.90267C7.73289 8.97533 7.63787 9.07873 7.56708 9.21287C7.49628 9.34515 7.46088 9.49979 7.46088 9.67678V12.287H6.44922Z"
      fill="#101828"
    />
    <path
      d="M13.3527 9.42526V8.86913L14.6969 7.75407C14.8087 7.66091 14.9046 7.57614 14.9848 7.49976C15.0649 7.42151 15.1263 7.34512 15.1692 7.2706C15.2121 7.19421 15.2335 7.1113 15.2335 7.02187C15.2335 6.87655 15.1757 6.7629 15.0602 6.68093C14.9447 6.59895 14.8031 6.55796 14.6354 6.55796C14.4566 6.55796 14.3122 6.60361 14.2023 6.6949C14.0942 6.78433 14.0402 6.90916 14.0402 7.06938H13.2996C13.2996 6.72285 13.4253 6.4499 13.6769 6.25055C13.9302 6.04934 14.2535 5.94873 14.6466 5.94873C14.913 5.94873 15.145 5.99624 15.3425 6.09126C15.5418 6.18441 15.6965 6.3111 15.8064 6.47133C15.9163 6.63155 15.9713 6.81134 15.9713 7.01069C15.9713 7.17092 15.9387 7.31997 15.8734 7.45784C15.8082 7.59384 15.7067 7.73078 15.5688 7.86865C15.431 8.00465 15.2549 8.15184 15.0406 8.3102L14.4649 8.76852V8.79368H16.0327V9.42526H13.3527Z"
      fill="#101828"
    />
  </svg>
);

export const layersIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.07422 11.9247L10.0605 15.9179L18.0468 11.9247M10.0605 3.93848L2.07422 7.93161L10.0605 11.9247L18.0468 7.93161L10.0605 3.93848Z"
      stroke="#101828"
      strokeWidth="1.2778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const percentIcon = (
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3999 4.09941L3.5999 13.8994M6.3999 5.14941C6.3999 6.11591 5.6164 6.89941 4.6499 6.89941C3.6834 6.89941 2.8999 6.11591 2.8999 5.14941C2.8999 4.18292 3.6834 3.39941 4.6499 3.39941C5.6164 3.39941 6.3999 4.18292 6.3999 5.14941ZM14.0999 12.8494C14.0999 13.8159 13.3164 14.5994 12.3499 14.5994C11.3834 14.5994 10.5999 13.8159 10.5999 12.8494C10.5999 11.8829 11.3834 11.0994 12.3499 11.0994C13.3164 11.0994 14.0999 11.8829 14.0999 12.8494Z"
      stroke="#0494FE"
      strokeWidth="1.848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const buildingIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.375 16.2385H3.97225M3.97225 16.2385H10.3613M3.97225 16.2385V6.01622C3.97225 5.12167 3.97225 4.67406 4.14635 4.33239C4.29948 4.03184 4.54365 3.78767 4.8442 3.63454C5.18586 3.46045 5.63347 3.46045 6.52802 3.46045H7.80582C8.70037 3.46045 9.14744 3.46045 9.48909 3.63454C9.78961 3.78767 10.0342 4.03184 10.1873 4.33239C10.3613 4.67372 10.3613 5.12079 10.3613 6.01359V8.44875M10.3613 16.2385H16.7503M10.3613 16.2385V8.44875M10.3613 8.44875L10.6499 8.18943C11.2536 7.64713 11.5555 7.3759 11.8967 7.27304C12.1973 7.18241 12.5181 7.18241 12.8187 7.27304C13.1601 7.37592 13.4621 7.64701 14.0659 8.18943L15.9027 9.83964C16.2148 10.12 16.3705 10.2604 16.4825 10.4286C16.5817 10.5777 16.6554 10.7422 16.7 10.9156C16.7503 11.1112 16.7503 11.3213 16.7503 11.7408V16.2385M16.7503 16.2385H18.3475"
      stroke="black"
      strokeWidth="1.2778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const buildingIconSmall = (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.52344 17.0734H4.21719M4.21719 17.0734H10.9922M4.21719 17.0734V6.23361C4.21719 5.28501 4.21719 4.81037 4.4018 4.44806C4.56418 4.12935 4.8231 3.87043 5.14181 3.70805C5.50412 3.52344 5.97876 3.52344 6.92736 3.52344H8.28236C9.23094 3.52344 9.70502 3.52344 10.0673 3.70805C10.386 3.87043 10.6454 4.12935 10.8077 4.44806C10.9922 4.81001 10.9922 5.28408 10.9922 6.23082V8.8131M10.9922 17.0734H17.7672M10.9922 17.0734V8.8131M10.9922 8.8131L11.2982 8.53811C11.9384 7.96305 12.2585 7.67544 12.6204 7.56636C12.9392 7.47026 13.2793 7.47026 13.5981 7.56636C13.9601 7.67545 14.2803 7.96293 14.9206 8.53811L16.8684 10.288C17.1994 10.5854 17.3645 10.7342 17.4832 10.9126C17.5884 11.0706 17.6666 11.2451 17.7138 11.429C17.7672 11.6364 17.7672 11.8592 17.7672 12.304V17.0734M17.7672 17.0734H19.4609"
      stroke="currentColor"
      strokeWidth="1.355"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const shoppingCartIcon = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 0.5H2.5L3.84 7.195C3.88572 7.4252 4.01095 7.63198 4.19377 7.77915C4.37659 7.92632 4.60535 8.0045 4.84 8H9.7C9.93465 8.0045 10.1634 7.92632 10.3462 7.77915C10.529 7.63198 10.6543 7.4252 10.7 7.195L11.5 3H3M5 10.5C5 10.7761 4.77614 11 4.5 11C4.22386 11 4 10.7761 4 10.5C4 10.2239 4.22386 10 4.5 10C4.77614 10 5 10.2239 5 10.5ZM10.5 10.5C10.5 10.7761 10.2761 11 10 11C9.72386 11 9.5 10.7761 9.5 10.5C9.5 10.2239 9.72386 10 10 10C10.2761 10 10.5 10.2239 10.5 10.5Z"
      stroke="#5C5C5C"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const bookOpenIcon = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9302_131503)">
      <path
        d="M6.99999 4.08333C6.99999 3.46449 6.75416 2.871 6.31657 2.43342C5.87899 1.99583 5.28549 1.75 4.66666 1.75H1.16666V10.5H5.24999C5.71412 10.5 6.15924 10.6844 6.48743 11.0126C6.81562 11.3408 6.99999 11.7859 6.99999 12.25M6.99999 4.08333V12.25M6.99999 4.08333C6.99999 3.46449 7.24582 2.871 7.68341 2.43342C8.12099 1.99583 8.71448 1.75 9.33332 1.75H12.8333V10.5H8.74999C8.28586 10.5 7.84074 10.6844 7.51255 11.0126C7.18436 11.3408 6.99999 11.7859 6.99999 12.25"
        stroke="#5C5C5C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9302_131503">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const synagogueIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.99993 3.21147L8.6482 3.51911L4.51115 7.01652H2.56824V14.7885H7.92798V12.716C7.92798 12.1371 8.40115 11.6797 8.99993 11.6797C9.59872 11.6797 10.0719 12.1371 10.0719 12.716V14.7885H15.4316V7.01652H13.4887L9.35167 3.51911L8.99993 3.21147ZM3.64019 4.42585C3.32823 4.87921 2.56824 4.94803 2.56824 5.80214C2.56824 6.28182 2.91997 6.49838 2.91997 6.49838H4.3604C4.3604 6.49838 4.71214 6.28182 4.71214 5.80214C4.71214 4.9035 3.99192 4.86505 3.64019 4.42585ZM14.3597 4.42585C14.0477 4.87921 13.2877 5.20305 13.2877 5.80214C13.2877 6.28182 13.6395 6.49838 13.6395 6.49838H15.0799C15.0799 6.49838 15.4316 6.28182 15.4316 5.80214C15.4316 5.15852 14.7114 4.86505 14.3597 4.42585ZM8.99993 4.58776L12.936 7.92325L13.0867 8.05278H14.3597V13.7523H11.1438V12.716C11.1438 11.5765 10.1787 10.6435 8.99993 10.6435C7.82121 10.6435 6.85603 11.5765 6.85603 12.716V13.7523H3.64019V8.05278H4.91313L5.06387 7.92325L8.99993 4.58776ZM8.99993 6.74126L8.53096 7.51846H7.60975L8.06198 8.29566L7.60975 9.07286H8.53096L8.99993 9.86625L9.46891 9.07286H10.3901L9.93789 8.29566L10.3901 7.51846H9.46891L8.99993 6.74126Z"
      fill="#5C5C5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99992 2.94577L9.48206 3.36747L13.5619 6.81652H15.6316V14.9885H9.87187V12.716C9.87187 12.2539 9.49468 11.8797 8.99992 11.8797C8.50516 11.8797 8.12797 12.2539 8.12797 12.716V14.9885H2.36823V6.81652H4.43792L8.51778 3.36747L8.99992 2.94577ZM4.51113 7.01652H2.56823V14.7885H7.92797V12.716C7.92797 12.1371 8.40114 11.6797 8.99992 11.6797C9.5987 11.6797 10.0719 12.1371 10.0719 12.716V14.7885H15.4316V7.01652H13.4887L9.35165 3.51912L8.99992 3.21148L8.64819 3.51912L4.51113 7.01652ZM3.62801 4.09071L3.79628 4.30083C3.86503 4.38668 3.9558 4.45791 4.06838 4.53434C4.09792 4.55439 4.13026 4.57557 4.16414 4.59777C4.25026 4.65419 4.34637 4.71715 4.43197 4.78473C4.55738 4.88373 4.68036 5.00659 4.77055 5.1756C4.86118 5.34545 4.91212 5.54956 4.91212 5.80215C4.91212 6.09452 4.80397 6.31041 4.69467 6.45223C4.64049 6.52254 4.58607 6.57472 4.54426 6.60997C4.52327 6.62766 4.50523 6.64128 4.49163 6.65098C4.48482 6.65584 4.47909 6.65973 4.47464 6.66267L4.46893 6.66638L4.46683 6.66771L4.46597 6.66825C4.46597 6.66825 4.46525 6.6687 4.36039 6.49839C4.36039 6.49839 4.71212 6.28182 4.71212 5.80215C4.71212 5.19581 4.38424 4.98108 4.0629 4.77063C3.9658 4.70704 3.8693 4.64384 3.78262 4.57034C3.731 4.52658 3.68287 4.47917 3.64017 4.42585C3.60172 4.48174 3.55646 4.53178 3.50666 4.57816C3.41658 4.66206 3.31164 4.73402 3.20521 4.80699C2.89309 5.02099 2.56823 5.24373 2.56823 5.80215C2.56823 6.28182 2.91996 6.49839 2.91996 6.49839C2.8151 6.6687 2.81493 6.66859 2.81493 6.66859L2.81352 6.66771L2.81141 6.66638L2.8057 6.66267C2.80125 6.65973 2.79553 6.65584 2.78872 6.65098C2.77512 6.64128 2.75708 6.62766 2.73609 6.60997C2.69428 6.57472 2.63986 6.52254 2.58568 6.45223C2.47638 6.31041 2.36823 6.09452 2.36823 5.80215C2.36823 5.557 2.42329 5.35792 2.51806 5.19154C2.61171 5.02714 2.73791 4.90565 2.86335 4.8067C2.93728 4.74838 3.02434 4.68852 3.10288 4.63452C3.14711 4.60411 3.18864 4.57556 3.2236 4.55019C3.33298 4.47081 3.41691 4.3975 3.47541 4.31248L3.62801 4.09071ZM2.91996 6.49839H4.36039L4.46597 6.66825L4.41702 6.69839H2.86332L2.81493 6.66859L2.91996 6.49839ZM14.3475 4.09071L14.5158 4.30083C14.5911 4.39483 14.6896 4.48526 14.805 4.58322C14.836 4.60952 14.8687 4.63676 14.9022 4.66474C14.9883 4.73644 15.0801 4.81299 15.1639 4.89101C15.3999 5.11088 15.6316 5.3951 15.6316 5.80215C15.6316 6.09452 15.5235 6.31041 15.4142 6.45223C15.36 6.52254 15.3056 6.57472 15.2637 6.60997C15.2428 6.62766 15.2247 6.64128 15.2111 6.65098C15.2043 6.65584 15.1986 6.65973 15.1941 6.66267L15.1884 6.66638L15.1863 6.66771L15.1855 6.66825C15.1855 6.66825 15.1847 6.6687 15.0799 6.49839C15.0799 6.49839 15.4316 6.28182 15.4316 5.80215C15.4316 5.36623 15.1012 5.09093 14.7787 4.82218C14.6813 4.74102 14.5846 4.66045 14.498 4.57623C14.4479 4.52759 14.4012 4.47774 14.3597 4.42585C14.3224 4.48007 14.2786 4.53244 14.2306 4.58365C14.1353 4.68515 14.023 4.78209 13.9097 4.87987C13.6023 5.14523 13.2877 5.41672 13.2877 5.80215C13.2877 6.28182 13.6395 6.49839 13.6395 6.49839C13.5346 6.6687 13.5344 6.66859 13.5344 6.66859L13.533 6.66771L13.5309 6.66638L13.5252 6.66267C13.5207 6.65973 13.515 6.65584 13.5082 6.65098C13.4946 6.64128 13.4766 6.62766 13.4556 6.60997C13.4138 6.57472 13.3594 6.52254 13.3052 6.45223C13.1959 6.31041 13.0877 6.09452 13.0877 5.80215C13.0877 5.41142 13.3376 5.12907 13.5707 4.91276C13.6362 4.85195 13.713 4.78557 13.7856 4.72273C13.8365 4.67877 13.8853 4.63655 13.9269 4.59917C14.0391 4.4983 14.1307 4.40578 14.1949 4.31248L14.3475 4.09071ZM13.6395 6.49839H15.0799L15.1855 6.66825L15.1365 6.69839H13.5828L13.5344 6.66859L13.6395 6.49839ZM13.0867 8.05279L12.936 7.92326L8.99992 4.58777L5.06386 7.92326L4.91311 8.05279H3.64017V13.7523H6.85602V12.716C6.85602 11.5765 7.82119 10.6435 8.99992 10.6435C10.1786 10.6435 11.1438 11.5765 11.1438 12.716V13.7523H14.3597V8.05279H13.0867ZM14.1597 8.25279H13.0126L12.8067 8.07584L12.8056 8.07495L8.99992 4.84992L5.1942 8.07495L5.19316 8.07584L4.98724 8.25279H3.84017V13.5523H6.65602V12.716C6.65602 11.4597 7.71717 10.4435 8.99992 10.4435C10.2827 10.4435 11.3438 11.4597 11.3438 12.716V13.5523H14.1597V8.25279ZM8.99992 6.35415L9.58181 7.31846H10.7379L10.1693 8.29566L10.7379 9.27287H9.58301L8.99992 10.2593L8.41684 9.27287H7.26197L7.83057 8.29566L7.26197 7.31846H8.41804L8.99992 6.35415ZM8.53094 7.51846H7.60974L8.06197 8.29566L7.60974 9.07287H8.53094L8.99992 9.86626L9.4689 9.07287H10.3901L9.93788 8.29566L10.3901 7.51846H9.4689L8.99992 6.74126L8.53094 7.51846Z"
      fill="#5C5C5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.92797 12.716C7.92797 12.1371 8.40114 11.6797 8.99992 11.6797C9.5987 11.6797 10.0719 12.1371 10.0719 12.716V14.7885H15.4316V7.01652H13.4887L9.35165 3.51912L8.99992 3.21148L8.64819 3.51912L4.51113 7.01652H2.56823V14.7885H7.92797V12.716ZM13.0867 8.05279L12.936 7.92326L8.99992 4.58777L5.06386 7.92326L4.91311 8.05279H3.64017V13.7523H6.85602V12.716C6.85602 11.5765 7.82119 10.6435 8.99992 10.6435C10.1786 10.6435 11.1438 11.5765 11.1438 12.716V13.7523H14.3597V8.05279H13.0867Z"
      fill="#5C5C5C"
    />
  </svg>
);

export const crossIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const messageIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="16" cy="16.124" rx="16" ry="15.876" fill="white" fillOpacity="0.29" />
    <rect x="20.5" width="10" height="9.92248" rx="4.96124" fill="#04FE3B" />
    <path
      d="M23.5 15.462C23.5029 16.5534 23.2459 17.63 22.75 18.6042C22.162 19.7715 21.2581 20.7533 20.1395 21.4397C19.021 22.1261 17.7319 22.49 16.4167 22.4905C15.3168 22.4933 14.2318 22.2383 13.25 21.7463L8.5 23.3173L10.0833 18.6042C9.58744 17.63 9.33047 16.5534 9.33333 15.462C9.33384 14.157 9.70051 12.8779 10.3923 11.768C11.084 10.6581 12.0735 9.76122 13.25 9.1778C14.2318 8.68576 15.3168 8.43077 16.4167 8.43362H16.8333C18.5703 8.5287 20.2109 9.25616 21.441 10.4767C22.671 11.6973 23.4042 13.3251 23.5 15.0486V15.462Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const promotionIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 1.5C6.45475 1.5 1.75 6.20475 1.75 12C1.75 17.7952 6.45475 22.5 12.25 22.5C18.0452 22.5 22.75 17.7952 22.75 12C22.75 6.20475 18.0452 1.5 12.25 1.5ZM12.25 3C17.2172 3 21.25 7.03275 21.25 12C21.25 16.9672 17.2172 21 12.25 21C7.28275 21 3.25 16.9672 3.25 12C3.25 7.03275 7.28275 3 12.25 3ZM15.517 13.524C16.3315 13.6717 16.8738 14.4525 16.726 15.267C16.5783 16.0815 15.7975 16.6238 14.983 16.476C14.1685 16.3283 13.6262 15.5475 13.774 14.733C13.9217 13.9185 14.7025 13.3762 15.517 13.524ZM15.4697 7.71975L7.96975 15.2197C7.67725 15.5122 7.67725 15.9878 7.96975 16.2803C8.26225 16.5728 8.73775 16.5728 9.03025 16.2803L16.5303 8.78025C16.8228 8.48775 16.8228 8.01225 16.5303 7.71975C16.2378 7.42725 15.7622 7.42725 15.4697 7.71975ZM9.517 7.524C10.3315 7.67175 10.8738 8.4525 10.726 9.267C10.5783 10.0815 9.7975 10.6237 8.983 10.476C8.1685 10.3282 7.62625 9.5475 7.774 8.733C7.92175 7.9185 8.7025 7.37625 9.517 7.524Z"
      fill="currentColor"
    />
  </svg>
);

export const filtersIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.25 12L18.25 12M3.25 6L21.25 6M9.25 18H15.25"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const threeDIcon = (
  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.63603 13.5131C4.71799 13.5131 3.90037 13.3567 3.18315 13.0438C2.47004 12.7268 1.90651 12.2919 1.49257 11.7393C1.08274 11.1825 0.87167 10.5404 0.859375 9.81297H3.53971C3.5561 10.1178 3.65651 10.386 3.84094 10.6176C4.02947 10.8452 4.27947 11.022 4.59094 11.148C4.90242 11.2739 5.25283 11.3369 5.64218 11.3369C6.04791 11.3369 6.40652 11.2658 6.718 11.1236C7.02948 10.9813 7.27333 10.7842 7.44956 10.5323C7.62579 10.2803 7.7139 9.98975 7.7139 9.66057C7.7139 9.32733 7.61964 9.0327 7.43112 8.77668C7.24669 8.51659 6.9803 8.31339 6.63193 8.16709C6.28767 8.02079 5.87783 7.94764 5.40242 7.94764H4.22824V6.00917H5.40242C5.80406 6.00917 6.15857 5.94008 6.46595 5.80191C6.77743 5.66374 7.01923 5.47273 7.19136 5.2289C7.36349 4.981 7.44956 4.69247 7.44956 4.36329C7.44956 4.05037 7.37374 3.77606 7.2221 3.54035C7.07456 3.30058 6.86554 3.11364 6.59505 2.97954C6.32865 2.84543 6.01718 2.77837 5.66062 2.77837C5.29996 2.77837 4.97004 2.84339 4.67086 2.97344C4.37168 3.09942 4.13193 3.28026 3.9516 3.51597C3.77127 3.75167 3.67496 4.02802 3.66266 4.345H1.11142C1.12372 3.62569 1.33069 2.99173 1.73233 2.4431C2.13397 1.89448 2.67495 1.46574 3.35528 1.15688C4.03971 0.84396 4.81226 0.6875 5.67291 0.6875C6.54177 0.6875 7.30202 0.84396 7.95366 1.15688C8.6053 1.4698 9.11145 1.89244 9.47211 2.42481C9.83686 2.95312 10.0172 3.54645 10.0131 4.2048C10.0172 4.90379 9.79793 5.48696 9.3553 5.9543C8.91678 6.42165 8.34505 6.71832 7.64013 6.8443V6.94183C8.56637 7.05968 9.27129 7.3787 9.75489 7.89888C10.2426 8.41499 10.4844 9.06115 10.4803 9.83735C10.4844 10.5485 10.2774 11.1805 9.8594 11.7332C9.44547 12.2858 8.87374 12.7207 8.14423 13.0377C7.41472 13.3547 6.57865 13.5131 5.63603 13.5131Z"
      fill="#0494FE"
    />
    <path
      d="M16.9306 13.3425H12.4675V0.858184H16.9675C18.2339 0.858184 19.3241 1.10811 20.238 1.60797C21.152 2.10377 21.8548 2.81698 22.3466 3.74761C22.8425 4.67824 23.0905 5.79175 23.0905 7.08813C23.0905 8.38858 22.8425 9.50615 22.3466 10.4408C21.8548 11.3755 21.1479 12.0928 20.2257 12.5927C19.3077 13.0925 18.2093 13.3425 16.9306 13.3425ZM15.1294 11.0809H16.82C17.6069 11.0809 18.2687 10.9427 18.8056 10.6664C19.3466 10.386 19.7524 9.95317 20.0229 9.36797C20.2974 8.77871 20.4347 8.01876 20.4347 7.08813C20.4347 6.16563 20.2974 5.41177 20.0229 4.82657C19.7524 4.24137 19.3487 3.8106 18.8118 3.53426C18.2749 3.25791 17.613 3.11974 16.8261 3.11974H15.1294V11.0809Z"
      fill="#0494FE"
    />
  </svg>
);

export const threeDIconGrey = (
  <svg width="35" height="21" viewBox="0 0 35 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.859375" y="0.34375" width="33.3333" height="20" rx="10" fill="#F2F4F7" />
    <path
      d="M12.8273 15.0942C12.1473 15.0942 11.5416 14.9783 11.0104 14.7465C10.4821 14.5117 10.0647 14.1896 9.7581 13.7802C9.45452 13.3678 9.29817 12.8922 9.28906 12.3534H11.2745C11.2866 12.5791 11.361 12.7778 11.4976 12.9494C11.6373 13.118 11.8225 13.2489 12.0532 13.3422C12.2839 13.4356 12.5435 13.4822 12.8319 13.4822C13.1324 13.4822 13.3981 13.4295 13.6288 13.3242C13.8595 13.2188 14.0401 13.0728 14.1707 12.8862C14.3012 12.6995 14.3665 12.4843 14.3665 12.2405C14.3665 11.9936 14.2967 11.7754 14.157 11.5857C14.0204 11.3931 13.8231 11.2426 13.565 11.1342C13.31 11.0258 13.0064 10.9716 12.6543 10.9716H11.7845V9.53573H12.6543C12.9518 9.53573 13.2144 9.48455 13.4421 9.3822C13.6728 9.27985 13.8519 9.13837 13.9794 8.95775C14.1069 8.77412 14.1707 8.56039 14.1707 8.31656C14.1707 8.08477 14.1145 7.88157 14.0022 7.70697C13.8929 7.52937 13.7381 7.39089 13.5377 7.29155C13.3404 7.19221 13.1097 7.14254 12.8455 7.14254C12.5784 7.14254 12.334 7.19071 12.1124 7.28704C11.8908 7.38036 11.7132 7.51432 11.5796 7.68891C11.446 7.86351 11.3747 8.06821 11.3656 8.30301H9.47577C9.48487 7.77019 9.63818 7.30058 9.93569 6.8942C10.2332 6.48781 10.6339 6.17022 11.1379 5.94144C11.6449 5.70965 12.2171 5.59375 12.8546 5.59375C13.4982 5.59375 14.0614 5.70965 14.5441 5.94144C15.0268 6.17323 15.4017 6.4863 15.6689 6.88065C15.9391 7.27199 16.0726 7.71149 16.0696 8.19916C16.0726 8.71693 15.9102 9.1489 15.5823 9.49509C15.2575 9.84127 14.834 10.061 14.3118 10.1543V10.2266C14.9979 10.3139 15.5201 10.5502 15.8783 10.9355C16.2396 11.3178 16.4187 11.7965 16.4157 12.3714C16.4187 12.8982 16.2654 13.3663 15.9557 13.7757C15.6491 14.1851 15.2256 14.5072 14.6853 14.742C14.1449 14.9768 13.5256 15.0942 12.8273 15.0942Z"
      fill="#0494FE"
    />
    <path
      d="M21.1937 14.9678H17.8877V5.72018H21.221C22.1591 5.72018 22.9666 5.90532 23.6436 6.27558C24.3206 6.64284 24.8413 7.17114 25.2056 7.8605C25.5729 8.54986 25.7566 9.37467 25.7566 10.335C25.7566 11.2983 25.5729 12.1261 25.2056 12.8184C24.8413 13.5108 24.3176 14.0421 23.6345 14.4124C22.9545 14.7827 22.1409 14.9678 21.1937 14.9678ZM19.8595 13.2926H21.1117C21.6946 13.2926 22.1849 13.1902 22.5826 12.9855C22.9833 12.7778 23.2839 12.4572 23.4842 12.0237C23.6876 11.5872 23.7893 11.0243 23.7893 10.335C23.7893 9.65162 23.6876 9.09321 23.4842 8.65973C23.2839 8.22625 22.9848 7.90716 22.5871 7.70246C22.1895 7.49776 21.6992 7.39541 21.1163 7.39541H19.8595V13.2926Z"
      fill="#0494FE"
    />
  </svg>
);

export const mapEducations = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M3.33594 16.9896C3.33594 16.437 3.55543 15.9071 3.94613 15.5164C4.33683 15.1257 4.86674 14.9063 5.41927 14.9063H16.6693M3.33594 16.9896C3.33594 17.5421 3.55543 18.072 3.94613 18.4627C4.33683 18.8534 4.86674 19.0729 5.41927 19.0729H16.6693V2.40625H5.41927C4.86674 2.40625 4.33683 2.62574 3.94613 3.01644C3.55543 3.40715 3.33594 3.93705 3.33594 4.48958V16.9896Z"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapShopping = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M7.5026 9.90885V5.74219C7.5026 4.36148 8.62185 3.24219 10.0026 3.24219C11.3834 3.24219 12.5026 4.36148 12.5026 5.74219V9.8816M8.66927 18.2422H11.3359C13.2028 18.2422 14.1362 18.2422 14.8493 17.8789C15.4764 17.5593 15.9864 17.0494 16.3059 16.4222C16.6693 15.7091 16.6693 14.7757 16.6693 12.9089V10.9089C16.6693 9.97544 16.6693 9.50869 16.4876 9.15219C16.3279 8.8386 16.0729 8.58363 15.7593 8.42385C15.4028 8.24219 14.936 8.24219 14.0026 8.24219H6.0026C5.06919 8.24219 4.60247 8.24219 4.24595 8.42385C3.93235 8.58363 3.67738 8.8386 3.5176 9.15219C3.33594 9.50869 3.33594 9.97544 3.33594 10.9089V12.9089C3.33594 14.7757 3.33594 15.7091 3.69925 16.4222C4.01883 17.0494 4.52876 17.5593 5.15597 17.8789C5.869 18.2422 6.80243 18.2422 8.66927 18.2422Z"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapTransport = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M4.16406 9.90885H15.8307M7.4974 15.7422L4.9974 18.2422M12.4974 15.7422L14.9974 18.2422M9.9974 9.90885V4.07552M6.66406 13.2422H6.6724M13.3307 13.2422H13.3391M6.83073 15.7422H13.1641C14.0975 15.7422 14.5642 15.7422 14.9207 15.5605C15.2343 15.4008 15.4893 15.1458 15.6491 14.8322C15.8307 14.4757 15.8307 14.0089 15.8307 13.0755V5.90885C15.8307 4.97544 15.8307 4.50872 15.6491 4.1522C15.4893 3.8386 15.2343 3.58363 14.9207 3.42385C14.5642 3.24219 14.0975 3.24219 13.1641 3.24219H6.83073C5.89731 3.24219 5.4306 3.24219 5.07408 3.42385C4.76047 3.58363 4.5055 3.8386 4.34572 4.1522C4.16406 4.50872 4.16406 4.97543 4.16406 5.90885V13.0755C4.16406 14.0089 4.16406 14.4757 4.34572 14.8322C4.5055 15.1458 4.76047 15.4008 5.07408 15.5605C5.4306 15.7422 5.8973 15.7422 6.83073 15.7422Z"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapWalking = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="21" viewBox="0 0 13 21" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00388 4.5C9.10848 4.5 10.0039 3.60457 10.0039 2.5C10.0039 1.39543 9.10848 0.5 8.00388 0.5C6.89938 0.5 6.00388 1.39543 6.00388 2.5C6.00388 3.60457 6.89938 4.5 8.00388 4.5ZM6.05668 5.10557C6.38798 4.93992 6.78378 4.97097 7.08518 5.18627L8.08518 5.90056C8.40328 6.1278 8.55978 6.51959 8.48588 6.90348L7.43708 12.347L11.836 18.9453C12.1423 19.4048 12.0182 20.0257 11.5586 20.3321C11.0991 20.6384 10.4782 20.5142 10.1719 20.0547L5.54548 13.1152L4.72999 11.8919C4.58724 11.6778 4.53254 11.4169 4.57726 11.1634L5.17378 7.78309L3.38852 8.6757L2.8167 11.5334C2.70833 12.075 2.18147 12.4261 1.63992 12.3178C1.09837 12.2094 0.747208 11.6825 0.855568 11.141L1.52335 7.80379C1.58389 7.50123 1.78072 7.24356 2.0567 7.10557L6.05668 5.10557ZM11.6877 11.4487L8.81318 10.4905L9.19478 8.5096L12.3202 9.5513C12.8441 9.726 13.1273 10.2923 12.9526 10.8162C12.778 11.3402 12.2117 11.6234 11.6877 11.4487ZM1.13232 19.0097L4.40025 13.2001L4.71346 13.6699L5.64488 15.0669L2.87547 19.9903C2.60471 20.4716 1.99499 20.6423 1.51364 20.3716C1.03228 20.1008 0.861558 19.4911 1.13232 19.0097Z"
    />
  </svg>
);

export const mapDriving = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.1638 5.30313C7.73316 5.30313 7.33555 5.53387 7.1219 5.90775L5.38528 8.94685L6.23716 9.65674C6.27303 9.68665 6.31837 9.70312 6.3652 9.70312H17.641C17.6879 9.70312 17.7331 9.68672 17.769 9.65683L18.621 8.94684L16.8844 5.90776C16.6708 5.53396 16.2732 5.30313 15.8425 5.30313H8.1638ZM20.6756 9.31743L21.5153 8.61771C21.8547 8.33486 21.9006 7.83041 21.6177 7.49098C21.3349 7.15156 20.8304 7.10569 20.491 7.38854L19.8694 7.90656L18.2736 5.11401C17.7751 4.24156 16.8473 3.70312 15.8425 3.70312H8.1638C7.159 3.70312 6.23123 4.24152 5.73271 5.11393L4.13692 7.90657L3.51529 7.38854C3.17587 7.1057 2.67141 7.15156 2.38857 7.49098C2.10572 7.8304 2.15158 8.33486 2.491 8.6177L3.3307 9.31745L2.83558 10.1839C2.42114 10.9092 2.20315 11.73 2.20315 12.5654V18.5031C2.20315 19.4973 3.00905 20.3031 4.00315 20.3031H5.00314C5.99724 20.3031 6.80314 19.4973 6.80314 18.5031V18.3031H17.2031V18.5031C17.2031 19.4973 18.009 20.3031 19.0031 20.3031H20.0031C20.9973 20.3031 21.8031 19.4973 21.8031 18.5031V12.5654C21.8031 11.73 21.5851 10.9092 21.1708 10.184L20.6756 9.31743ZM19.4272 10.3577L18.7935 10.8858C18.47 11.1555 18.0621 11.3031 17.641 11.3031H6.3652C5.94418 11.3031 5.5364 11.1556 5.21287 10.8859L4.57906 10.3577L4.22477 10.9777C3.94847 11.4613 3.80315 12.0084 3.80315 12.5654V18.5031C3.80315 18.6136 3.89268 18.7031 4.00315 18.7031H5.00314C5.11361 18.7031 5.20315 18.6136 5.20315 18.5031V17.5031C5.20315 17.0613 5.56132 16.7031 6.00314 16.7031H18.0031C18.445 16.7031 18.8031 17.0613 18.8031 17.5031V18.5031C18.8031 18.6136 18.8927 18.7031 19.0031 18.7031H20.0031C20.1136 18.7031 20.2031 18.6136 20.2031 18.5031V12.5654C20.2031 12.0085 20.0578 11.4613 19.7815 10.9777L19.4272 10.3577ZM5.20315 14.0031C5.20315 13.2852 5.78514 12.7031 6.50315 12.7031C7.22115 12.7031 7.80315 13.2852 7.80315 14.0031C7.80315 14.721 7.22115 15.3031 6.50315 15.3031C5.78514 15.3031 5.20315 14.721 5.20315 14.0031ZM16.2031 14.0031C16.2031 13.2852 16.7852 12.7031 17.5031 12.7031C18.2211 12.7031 18.8031 13.2852 18.8031 14.0031C18.8031 14.7211 18.2211 15.3031 17.5031 15.3031C16.7852 15.3031 16.2031 14.7211 16.2031 14.0031Z"
    />
  </svg>
);

export const mapCycling = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
    <path d="M18.6372 5.38767C18.5935 5.38767 18.5515 5.39329 18.5087 5.39441L17.7792 1.12917C17.7397 0.899115 17.6027 0.697288 17.4044 0.574541C17.2065 0.451892 16.9649 0.420484 16.741 0.487988L14.5442 1.15335C14.1147 1.28362 13.8719 1.73768 14.0021 2.16791C14.1324 2.5978 14.5879 2.84143 15.016 2.71063L16.33 2.31254L16.6312 4.06847H9.71501V3.72284L10.5651 3.50826C10.9029 3.42323 11.1436 3.10822 11.1235 2.7475C11.1008 2.33872 10.7504 2.02607 10.3411 2.04951L7.20111 2.22794C7.13849 2.23185 7.06918 2.2422 7.00568 2.25803C6.44812 2.39914 6.10942 2.96565 6.2502 3.52341C6.39097 4.08117 6.9582 4.41917 7.51582 4.27845L8.08764 4.13392V4.66218L7.41876 5.81423C6.78554 5.54021 6.09301 5.38767 5.36571 5.38767C2.40718 5.38767 0 7.88951 0 10.9646C0 14.0403 2.40718 16.542 5.36571 16.542C8.05614 16.542 10.2848 14.4684 10.6651 11.7782H11.5327C11.7639 11.7782 11.984 11.6797 12.1382 11.5073L13.3316 10.1745C13.2958 10.4335 13.2711 10.6958 13.2711 10.9646C13.2711 14.0403 15.6787 16.5421 18.6372 16.5421C21.5944 16.5421 24 14.0403 24 10.9646C24 7.88951 21.5944 5.38767 18.6372 5.38767ZM5.36571 14.9149C3.30431 14.9149 1.62693 13.1428 1.62693 10.9646C1.62693 8.78659 3.30431 7.01484 5.36571 7.01484C5.79472 7.01484 6.20018 7.1074 6.58469 7.24876L4.66191 10.556C4.51566 10.8075 4.51483 11.1181 4.6602 11.3703C4.80473 11.6226 5.07411 11.7783 5.36571 11.7783H9.02048C8.6646 13.5671 7.16164 14.9149 5.36571 14.9149ZM9.02048 10.1511H6.78007L7.95615 8.1286C8.48348 8.66731 8.86418 9.36443 9.02048 10.1511ZM11.1689 10.1511H10.6651C10.4697 8.76471 9.78647 7.54114 8.79653 6.68221L9.37012 5.69544H15.1565L11.1689 10.1511ZM18.6372 14.9149C16.5754 14.9149 14.8984 13.1428 14.8984 10.9646C14.8984 9.32926 15.8438 7.92297 17.188 7.32393L17.8346 11.1021C17.9032 11.4987 18.2465 11.7782 18.6356 11.7782C18.6817 11.7782 18.728 11.7747 18.7737 11.7667C19.2175 11.6909 19.5145 11.2701 19.4389 10.8273L18.7889 7.03111C20.7776 7.11776 22.3731 8.84179 22.3731 10.9646C22.3731 13.1428 20.6965 14.9149 18.6372 14.9149Z" />
  </svg>
);

export const mapParks = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 17.5H18" strokeWidth="1.25" />
    <path
      d="M10 17.5L10 16.1667L10.5 15.5L13 15.5L15.5 15.5L16 16.1667L16 17.5"
      strokeWidth="1.25"
    />
    <path d="M7 17.5V8.5" strokeWidth="1.25" />
    <path d="M5 7.5L7 9.5" strokeWidth="1.25" />
    <path d="M9 6.5L7 9.5" strokeWidth="1.25" />
    <path
      d="M11.5 8C11.5 12 9 13 7 13C5.5 13 3 12 3 8C3 4 5.5 3 7 3C9 3 11.5 4 11.5 8Z"
      strokeWidth="1.25"
    />
  </svg>
);

export const mapHospitals = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M6.61589 5.22266H5.11589C4.18247 5.22266 3.71575 5.22266 3.35924 5.40431C3.04563 5.5641 2.79066 5.81906 2.63088 6.13267C2.44922 6.48919 2.44922 6.95591 2.44922 7.88932V15.056C2.44922 15.9894 2.44922 16.4562 2.63088 16.8127C2.79066 17.1262 3.04563 17.3812 3.35924 17.541C3.71575 17.7227 4.18247 17.7227 5.11589 17.7227H16.4492C17.3826 17.7227 17.8494 17.7227 18.2059 17.541C18.5195 17.3812 18.7745 17.1262 18.9342 16.8127C19.1159 16.4562 19.1159 15.9894 19.1159 15.056V7.88932C19.1159 6.9559 19.1159 6.48919 18.9342 6.13267C18.7745 5.81906 18.5195 5.5641 18.2059 5.40431C17.8494 5.22266 17.3826 5.22266 16.4492 5.22266H14.9492M2.44922 8.55599H4.11589M17.4492 8.55599H19.1159M2.44922 11.8893H4.11589M17.4492 11.8893H19.1159M10.7826 5.22266V8.55599M9.11589 6.88932H12.4492M14.9492 17.7227V5.38932C14.9492 4.45591 14.9492 3.98919 14.7676 3.63267C14.6078 3.31906 14.3528 3.0641 14.0392 2.90431C13.6827 2.72266 13.216 2.72266 12.2826 2.72266H9.28255C8.34913 2.72266 7.88242 2.72266 7.5259 2.90431C7.21229 3.0641 6.95733 3.31906 6.79754 3.63267C6.61589 3.98919 6.61589 4.45591 6.61589 5.38932V17.7227H14.9492ZM12.4492 17.7227V14.3893C12.4492 13.4688 11.7031 12.7227 10.7826 12.7227C9.86205 12.7227 9.11589 13.4688 9.11589 14.3893V17.7227H12.4492Z"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapRestaurants = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M18.2812 11.277L17.7051 11.8244C17.0856 12.4129 16.1213 12.4375 15.4725 11.8814L14.7826 11.29C14.1584 10.7551 13.2374 10.7551 12.6132 11.29L11.8659 11.9307C11.2418 12.4656 10.3207 12.4656 9.69658 11.9307L8.94923 11.29C8.32508 10.7551 7.40408 10.7551 6.77993 11.29L6.08996 11.8814C5.44117 12.4375 4.47692 12.4129 3.8574 11.8244L3.28125 11.277M10.7812 4.11035C6.39452 4.11035 4.57358 5.53578 3.8177 6.71919C3.32221 7.49493 4.02744 8.27702 4.94792 8.27702H16.6146C17.5351 8.27702 18.2402 7.49493 17.7448 6.71919C16.9889 5.53578 15.168 4.11035 10.7812 4.11035ZM4.53125 14.9437H17.0312C17.7216 14.9437 18.2812 15.5034 18.2812 16.1937C18.2812 16.884 17.7216 17.4437 17.0312 17.4437H4.53125C3.84089 17.4437 3.28125 16.884 3.28125 16.1937C3.28125 15.5034 3.84089 14.9437 4.53125 14.9437Z"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapGyms = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clipPath="url(#clip0_4811_180557)">
      <path
        d="M6.94661 6.16602H4.61328C4.33714 6.16602 4.11328 6.38987 4.11328 6.66602V13.9993C4.11328 14.2755 4.33714 14.4993 4.61328 14.4993H6.94661C7.22276 14.4993 7.44661 14.2755 7.44661 13.9993V6.66602C7.44661 6.38987 7.22276 6.16602 6.94661 6.16602Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9466 6.16602H14.6133C14.3371 6.16602 14.1133 6.38987 14.1133 6.66602V13.9993C14.1133 14.2755 14.3371 14.4993 14.6133 14.4993H16.9466C17.2228 14.4993 17.4466 14.2755 17.4466 13.9993V6.66602C17.4466 6.38987 17.2228 6.16602 16.9466 6.16602Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.61328 12.333V8.33301C1.61328 8.05687 1.83714 7.83301 2.11328 7.83301H3.61328C3.88942 7.83301 4.11328 8.05687 4.11328 8.33301V12.333C4.11328 12.6092 3.88942 12.833 3.61328 12.833H2.11328C1.83714 12.833 1.61328 12.6092 1.61328 12.333Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9492 12.333V8.33301C19.9492 8.05687 19.7254 7.83301 19.4492 7.83301H17.9492C17.6731 7.83301 17.4492 8.05687 17.4492 8.33301V12.333C17.4492 12.6092 17.6731 12.833 17.9492 12.833H19.4492C19.7254 12.833 19.9492 12.6092 19.9492 12.333Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44922 10.333H14.1159"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4811_180557">
        <rect width="20" height="20" transform="translate(0.78125 0.333008)" />
      </clipPath>
    </defs>
  </svg>
);

export const mapPharmacies = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M12.3646 15.8887H9.19792C8.92178 15.8887 8.69792 15.6648 8.69792 15.3887V13.472C8.69792 13.1958 8.47406 12.972 8.19792 12.972H6.28125C6.00511 12.972 5.78125 12.7482 5.78125 12.472V9.30534C5.78125 9.0292 6.00511 8.80534 6.28125 8.80534H8.19792C8.47406 8.80534 8.69792 8.58148 8.69792 8.30534V6.38867C8.69792 6.11253 8.92178 5.88867 9.19792 5.88867H12.3646C12.6407 5.88867 12.8646 6.11253 12.8646 6.38867V8.30534C12.8646 8.58148 13.0884 8.80534 13.3646 8.80534H15.2812C15.5574 8.80534 15.7812 9.0292 15.7812 9.30534V12.472C15.7812 12.7482 15.5574 12.972 15.2812 12.972H13.3646C13.0884 12.972 12.8646 13.1958 12.8646 13.472V15.3887C12.8646 15.6648 12.6407 15.8887 12.3646 15.8887Z"
      strokeWidth="1.25"
    />
    <path
      d="M10.7826 19.2223C15.3849 19.2223 19.1159 15.4913 19.1159 10.889C19.1159 6.28662 15.3849 2.55566 10.7826 2.55566C6.18018 2.55566 2.44922 6.28662 2.44922 10.889C2.44922 15.4913 6.18018 19.2223 10.7826 19.2223Z"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const spinnerIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <style
      dangerouslySetInnerHTML={{
        __html: `
        .spinner_Wezc{fill:currentColor;transform-origin:center;animation:spinner_Oiah 1s step-end infinite}
        @keyframes spinner_Oiah{
          8.3%{transform:rotate(30deg)}
          16.6%{transform:rotate(60deg)}
          25%{transform:rotate(90deg)}
          33.3%{transform:rotate(120deg)}
          41.6%{transform:rotate(150deg)}
          50%{transform:rotate(180deg)}
          58.3%{transform:rotate(210deg)}
          66.6%{transform:rotate(240deg)}
          75%{transform:rotate(270deg)}
          83.3%{transform:rotate(300deg)}
          91.6%{transform:rotate(330deg)}
          100%{transform:rotate(360deg)}
        }
      `,
      }}
    />
    <g className="spinner_Wezc">
      <circle cx="12" cy="2.5" r="1.5" opacity=".14" />
      <circle cx="16.75" cy="3.77" r="1.5" opacity=".29" />
      <circle cx="20.23" cy="7.25" r="1.5" opacity=".43" />
      <circle cx="21.50" cy="12.00" r="1.5" opacity=".57" />
      <circle cx="20.23" cy="16.75" r="1.5" opacity=".71" />
      <circle cx="16.75" cy="20.23" r="1.5" opacity=".86" />
      <circle cx="12" cy="21.5" r="1.5" />
    </g>
  </svg>
);

export const lockIcon = (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9778_240950)">
      <path
        d="M6.27582 10.1099V6.76842C6.27582 5.66064 6.71588 4.59824 7.49919 3.81493C8.2825 3.03161 9.34491 2.59155 10.4527 2.59155C11.5605 2.59155 12.6229 3.03161 13.4062 3.81493C14.1895 4.59824 14.6295 5.66064 14.6295 6.76842V10.1099M4.60507 10.1099H16.3003C17.223 10.1099 17.971 10.8579 17.971 11.7807V17.6283C17.971 18.551 17.223 19.299 16.3003 19.299H4.60507C3.68234 19.299 2.93433 18.551 2.93433 17.6283V11.7807C2.93433 10.8579 3.68234 10.1099 4.60507 10.1099Z"
        stroke="currentColor"
        strokeWidth="1.78213"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9778_240950">
        <rect
          width="20.0489"
          height="20.0489"
          fill="currentColor"
          transform="translate(0.428223 0.920898)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const pano360Icon = (
  <svg width="27" height="11" viewBox="0 0 27 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_10194_146" fill="white">
      <path d="M3.89566 10.7045C3.27197 10.7045 2.71758 10.5977 2.23249 10.384C1.75028 10.1703 1.36914 9.87294 1.08906 9.4918C0.808973 9.11065 0.660269 8.67032 0.642944 8.17079H2.27147C2.28591 8.41044 2.36531 8.61978 2.50969 8.79881C2.65406 8.97494 2.84607 9.1121 3.08573 9.21027C3.32539 9.30844 3.59393 9.35753 3.89133 9.35753C4.20895 9.35753 4.49048 9.30267 4.73592 9.19294C4.98135 9.08033 5.17336 8.92441 5.31196 8.72518C5.45056 8.52594 5.51842 8.29639 5.51553 8.03652C5.51842 7.76798 5.44912 7.53121 5.30763 7.3262C5.16615 7.12119 4.96114 6.96094 4.6926 6.84544C4.42696 6.72994 4.10645 6.67219 3.73108 6.67219H2.94714V5.43348H3.73108C4.04004 5.43348 4.31002 5.38006 4.54101 5.27322C4.7749 5.16639 4.95825 5.01624 5.09107 4.82278C5.2239 4.62643 5.28886 4.39977 5.28598 4.14278C5.28886 3.89157 5.23256 3.67357 5.11706 3.48877C5.00445 3.30109 4.84419 3.15527 4.6363 3.05132C4.43129 2.94737 4.19019 2.8954 3.91299 2.8954C3.64157 2.8954 3.39036 2.94449 3.15936 3.04266C2.92837 3.14083 2.74213 3.28088 2.60064 3.46279C2.45915 3.64181 2.38408 3.85548 2.37542 4.1038H0.829185C0.840735 3.60716 0.983664 3.17115 1.25797 2.79578C1.53517 2.41753 1.90476 2.12301 2.36676 1.91222C2.82875 1.69855 3.34705 1.59171 3.92165 1.59171C4.51358 1.59171 5.02755 1.70288 5.46355 1.92521C5.90245 2.14466 6.24172 2.44063 6.48138 2.81311C6.72104 3.18559 6.84087 3.59705 6.84087 4.0475C6.84376 4.54703 6.6965 4.96571 6.39909 5.30354C6.10457 5.64137 5.71765 5.86226 5.23833 5.96621V6.03551C5.86202 6.12213 6.3399 6.35313 6.67196 6.7285C7.0069 7.10098 7.17293 7.56442 7.17004 8.11881C7.17004 8.61545 7.02856 9.06012 6.74559 9.45282C6.4655 9.84262 6.07858 10.1487 5.58483 10.371C5.09396 10.5934 4.53091 10.7045 3.89566 10.7045Z" />
      <path d="M11.9051 10.7045C11.4807 10.7016 11.0663 10.628 10.6621 10.4836C10.2578 10.3364 9.894 10.0982 9.5706 9.76899C9.24721 9.43694 8.99022 8.9966 8.79965 8.44798C8.60908 7.89648 8.51523 7.21359 8.51812 6.39933C8.51812 5.63993 8.59897 4.96282 8.76067 4.368C8.92237 3.77319 9.15481 3.27077 9.45799 2.86075C9.76117 2.44784 10.1264 2.13311 10.5538 1.91655C10.984 1.69999 11.4648 1.59171 11.9961 1.59171C12.5533 1.59171 13.0471 1.70144 13.4773 1.92088C13.9104 2.14033 14.2598 2.44063 14.5255 2.82177C14.7911 3.20003 14.9557 3.62737 15.0192 4.1038H13.4383C13.3575 3.76308 13.1915 3.49166 12.9403 3.28954C12.6919 3.08453 12.3772 2.98202 11.9961 2.98202C11.381 2.98202 10.9075 3.24911 10.5754 3.78329C10.2463 4.31747 10.0802 5.05089 10.0773 5.98354H10.138C10.2795 5.72944 10.4628 5.51144 10.688 5.32953C10.9133 5.14762 11.1674 5.00758 11.4503 4.9094C11.7362 4.80834 12.0379 4.75781 12.3556 4.75781C12.8753 4.75781 13.3416 4.88197 13.7545 5.13029C14.1703 5.37861 14.4995 5.72078 14.742 6.15678C14.9846 6.5899 15.1044 7.08655 15.1015 7.64671C15.1044 8.22998 14.9716 8.75405 14.7031 9.21893C14.4345 9.68093 14.0606 10.0447 13.5813 10.3104C13.102 10.576 12.5432 10.7074 11.9051 10.7045ZM11.8964 9.40517C12.2112 9.40517 12.4927 9.32866 12.741 9.17562C12.9894 9.02258 13.1857 8.81613 13.3301 8.55626C13.4744 8.29639 13.5452 8.00476 13.5423 7.68136C13.5452 7.36374 13.4759 7.07644 13.3344 6.81946C13.1958 6.56247 13.0038 6.35891 12.7584 6.20876C12.5129 6.05861 12.2328 5.98354 11.9181 5.98354C11.6842 5.98354 11.4662 6.02829 11.2641 6.1178C11.062 6.20731 10.8858 6.33147 10.7357 6.49028C10.5855 6.64621 10.4672 6.82812 10.3805 7.03601C10.2968 7.24102 10.2535 7.46047 10.2506 7.69435C10.2535 8.00331 10.3257 8.28773 10.4672 8.5476C10.6086 8.80747 10.8035 9.01537 11.0519 9.17129C11.3002 9.32721 11.5817 9.40517 11.8964 9.40517Z" />
      <path d="M19.8442 10.7522C19.131 10.7522 18.5188 10.5717 18.0077 10.2108C17.4996 9.84695 17.1083 9.32288 16.834 8.63855C16.5626 7.95134 16.4269 7.12408 16.4269 6.15678C16.4298 5.18949 16.5669 4.36656 16.8383 3.68801C17.1126 3.00657 17.5039 2.48682 18.0121 2.12878C18.5232 1.77074 19.1339 1.59171 19.8442 1.59171C20.5545 1.59171 21.1652 1.77074 21.6763 2.12878C22.1873 2.48682 22.5786 3.00657 22.85 3.68801C23.1243 4.36945 23.2615 5.19237 23.2615 6.15678C23.2615 7.12697 23.1243 7.95567 22.85 8.64288C22.5786 9.32721 22.1873 9.84984 21.6763 10.2108C21.1681 10.5717 20.5574 10.7522 19.8442 10.7522ZM19.8442 9.39651C20.3986 9.39651 20.836 9.12365 21.1565 8.57792C21.4799 8.0293 21.6416 7.22226 21.6416 6.15678C21.6416 5.45224 21.568 4.86032 21.4207 4.381C21.2735 3.90168 21.0656 3.54075 20.797 3.2982C20.5285 3.05277 20.2109 2.93005 19.8442 2.93005C19.2927 2.93005 18.8567 3.20436 18.5362 3.75297C18.2156 4.2987 18.0539 5.09997 18.0511 6.15678C18.0482 6.86421 18.1189 7.45903 18.2633 7.94123C18.4106 8.42344 18.6184 8.78726 18.887 9.03269C19.1555 9.27524 19.4746 9.39651 19.8442 9.39651Z" />
      <path d="M26.2926 2.07504C26.2926 2.78203 25.7195 3.35516 25.0125 3.35516C24.3055 3.35516 23.7324 2.78203 23.7324 2.07504C23.7324 1.36805 24.3055 0.794922 25.0125 0.794922C25.7195 0.794922 26.2926 1.36805 26.2926 2.07504Z" />
    </mask>
    <path
      d="M3.89566 10.7045C3.27197 10.7045 2.71758 10.5977 2.23249 10.384C1.75028 10.1703 1.36914 9.87294 1.08906 9.4918C0.808973 9.11065 0.660269 8.67032 0.642944 8.17079H2.27147C2.28591 8.41044 2.36531 8.61978 2.50969 8.79881C2.65406 8.97494 2.84607 9.1121 3.08573 9.21027C3.32539 9.30844 3.59393 9.35753 3.89133 9.35753C4.20895 9.35753 4.49048 9.30267 4.73592 9.19294C4.98135 9.08033 5.17336 8.92441 5.31196 8.72518C5.45056 8.52594 5.51842 8.29639 5.51553 8.03652C5.51842 7.76798 5.44912 7.53121 5.30763 7.3262C5.16615 7.12119 4.96114 6.96094 4.6926 6.84544C4.42696 6.72994 4.10645 6.67219 3.73108 6.67219H2.94714V5.43348H3.73108C4.04004 5.43348 4.31002 5.38006 4.54101 5.27322C4.7749 5.16639 4.95825 5.01624 5.09107 4.82278C5.2239 4.62643 5.28886 4.39977 5.28598 4.14278C5.28886 3.89157 5.23256 3.67357 5.11706 3.48877C5.00445 3.30109 4.84419 3.15527 4.6363 3.05132C4.43129 2.94737 4.19019 2.8954 3.91299 2.8954C3.64157 2.8954 3.39036 2.94449 3.15936 3.04266C2.92837 3.14083 2.74213 3.28088 2.60064 3.46279C2.45915 3.64181 2.38408 3.85548 2.37542 4.1038H0.829185C0.840735 3.60716 0.983664 3.17115 1.25797 2.79578C1.53517 2.41753 1.90476 2.12301 2.36676 1.91222C2.82875 1.69855 3.34705 1.59171 3.92165 1.59171C4.51358 1.59171 5.02755 1.70288 5.46355 1.92521C5.90245 2.14466 6.24172 2.44063 6.48138 2.81311C6.72104 3.18559 6.84087 3.59705 6.84087 4.0475C6.84376 4.54703 6.6965 4.96571 6.39909 5.30354C6.10457 5.64137 5.71765 5.86226 5.23833 5.96621V6.03551C5.86202 6.12213 6.3399 6.35313 6.67196 6.7285C7.0069 7.10098 7.17293 7.56442 7.17004 8.11881C7.17004 8.61545 7.02856 9.06012 6.74559 9.45282C6.4655 9.84262 6.07858 10.1487 5.58483 10.371C5.09396 10.5934 4.53091 10.7045 3.89566 10.7045Z"
      fill="white"
    />
    <path
      d="M11.9051 10.7045C11.4807 10.7016 11.0663 10.628 10.6621 10.4836C10.2578 10.3364 9.894 10.0982 9.5706 9.76899C9.24721 9.43694 8.99022 8.9966 8.79965 8.44798C8.60908 7.89648 8.51523 7.21359 8.51812 6.39933C8.51812 5.63993 8.59897 4.96282 8.76067 4.368C8.92237 3.77319 9.15481 3.27077 9.45799 2.86075C9.76117 2.44784 10.1264 2.13311 10.5538 1.91655C10.984 1.69999 11.4648 1.59171 11.9961 1.59171C12.5533 1.59171 13.0471 1.70144 13.4773 1.92088C13.9104 2.14033 14.2598 2.44063 14.5255 2.82177C14.7911 3.20003 14.9557 3.62737 15.0192 4.1038H13.4383C13.3575 3.76308 13.1915 3.49166 12.9403 3.28954C12.6919 3.08453 12.3772 2.98202 11.9961 2.98202C11.381 2.98202 10.9075 3.24911 10.5754 3.78329C10.2463 4.31747 10.0802 5.05089 10.0773 5.98354H10.138C10.2795 5.72944 10.4628 5.51144 10.688 5.32953C10.9133 5.14762 11.1674 5.00758 11.4503 4.9094C11.7362 4.80834 12.0379 4.75781 12.3556 4.75781C12.8753 4.75781 13.3416 4.88197 13.7545 5.13029C14.1703 5.37861 14.4995 5.72078 14.742 6.15678C14.9846 6.5899 15.1044 7.08655 15.1015 7.64671C15.1044 8.22998 14.9716 8.75405 14.7031 9.21893C14.4345 9.68093 14.0606 10.0447 13.5813 10.3104C13.102 10.576 12.5432 10.7074 11.9051 10.7045ZM11.8964 9.40517C12.2112 9.40517 12.4927 9.32866 12.741 9.17562C12.9894 9.02258 13.1857 8.81613 13.3301 8.55626C13.4744 8.29639 13.5452 8.00476 13.5423 7.68136C13.5452 7.36374 13.4759 7.07644 13.3344 6.81946C13.1958 6.56247 13.0038 6.35891 12.7584 6.20876C12.5129 6.05861 12.2328 5.98354 11.9181 5.98354C11.6842 5.98354 11.4662 6.02829 11.2641 6.1178C11.062 6.20731 10.8858 6.33147 10.7357 6.49028C10.5855 6.64621 10.4672 6.82812 10.3805 7.03601C10.2968 7.24102 10.2535 7.46047 10.2506 7.69435C10.2535 8.00331 10.3257 8.28773 10.4672 8.5476C10.6086 8.80747 10.8035 9.01537 11.0519 9.17129C11.3002 9.32721 11.5817 9.40517 11.8964 9.40517Z"
      fill="white"
    />
    <path
      d="M19.8442 10.7522C19.131 10.7522 18.5188 10.5717 18.0077 10.2108C17.4996 9.84695 17.1083 9.32288 16.834 8.63855C16.5626 7.95134 16.4269 7.12408 16.4269 6.15678C16.4298 5.18949 16.5669 4.36656 16.8383 3.68801C17.1126 3.00657 17.5039 2.48682 18.0121 2.12878C18.5232 1.77074 19.1339 1.59171 19.8442 1.59171C20.5545 1.59171 21.1652 1.77074 21.6763 2.12878C22.1873 2.48682 22.5786 3.00657 22.85 3.68801C23.1243 4.36945 23.2615 5.19237 23.2615 6.15678C23.2615 7.12697 23.1243 7.95567 22.85 8.64288C22.5786 9.32721 22.1873 9.84984 21.6763 10.2108C21.1681 10.5717 20.5574 10.7522 19.8442 10.7522ZM19.8442 9.39651C20.3986 9.39651 20.836 9.12365 21.1565 8.57792C21.4799 8.0293 21.6416 7.22226 21.6416 6.15678C21.6416 5.45224 21.568 4.86032 21.4207 4.381C21.2735 3.90168 21.0656 3.54075 20.797 3.2982C20.5285 3.05277 20.2109 2.93005 19.8442 2.93005C19.2927 2.93005 18.8567 3.20436 18.5362 3.75297C18.2156 4.2987 18.0539 5.09997 18.0511 6.15678C18.0482 6.86421 18.1189 7.45903 18.2633 7.94123C18.4106 8.42344 18.6184 8.78726 18.887 9.03269C19.1555 9.27524 19.4746 9.39651 19.8442 9.39651Z"
      fill="white"
    />
    <path
      d="M3.89566 10.7045C3.27197 10.7045 2.71758 10.5977 2.23249 10.384C1.75028 10.1703 1.36914 9.87294 1.08906 9.4918C0.808973 9.11065 0.660269 8.67032 0.642944 8.17079H2.27147C2.28591 8.41044 2.36531 8.61978 2.50969 8.79881C2.65406 8.97494 2.84607 9.1121 3.08573 9.21027C3.32539 9.30844 3.59393 9.35753 3.89133 9.35753C4.20895 9.35753 4.49048 9.30267 4.73592 9.19294C4.98135 9.08033 5.17336 8.92441 5.31196 8.72518C5.45056 8.52594 5.51842 8.29639 5.51553 8.03652C5.51842 7.76798 5.44912 7.53121 5.30763 7.3262C5.16615 7.12119 4.96114 6.96094 4.6926 6.84544C4.42696 6.72994 4.10645 6.67219 3.73108 6.67219H2.94714V5.43348H3.73108C4.04004 5.43348 4.31002 5.38006 4.54101 5.27322C4.7749 5.16639 4.95825 5.01624 5.09107 4.82278C5.2239 4.62643 5.28886 4.39977 5.28598 4.14278C5.28886 3.89157 5.23256 3.67357 5.11706 3.48877C5.00445 3.30109 4.84419 3.15527 4.6363 3.05132C4.43129 2.94737 4.19019 2.8954 3.91299 2.8954C3.64157 2.8954 3.39036 2.94449 3.15936 3.04266C2.92837 3.14083 2.74213 3.28088 2.60064 3.46279C2.45915 3.64181 2.38408 3.85548 2.37542 4.1038H0.829185C0.840735 3.60716 0.983664 3.17115 1.25797 2.79578C1.53517 2.41753 1.90476 2.12301 2.36676 1.91222C2.82875 1.69855 3.34705 1.59171 3.92165 1.59171C4.51358 1.59171 5.02755 1.70288 5.46355 1.92521C5.90245 2.14466 6.24172 2.44063 6.48138 2.81311C6.72104 3.18559 6.84087 3.59705 6.84087 4.0475C6.84376 4.54703 6.6965 4.96571 6.39909 5.30354C6.10457 5.64137 5.71765 5.86226 5.23833 5.96621V6.03551C5.86202 6.12213 6.3399 6.35313 6.67196 6.7285C7.0069 7.10098 7.17293 7.56442 7.17004 8.11881C7.17004 8.61545 7.02856 9.06012 6.74559 9.45282C6.4655 9.84262 6.07858 10.1487 5.58483 10.371C5.09396 10.5934 4.53091 10.7045 3.89566 10.7045Z"
      stroke="white"
      strokeWidth="1.19304"
      mask="url(#path-1-inside-1_10194_146)"
    />
    <path
      d="M11.9051 10.7045C11.4807 10.7016 11.0663 10.628 10.6621 10.4836C10.2578 10.3364 9.894 10.0982 9.5706 9.76899C9.24721 9.43694 8.99022 8.9966 8.79965 8.44798C8.60908 7.89648 8.51523 7.21359 8.51812 6.39933C8.51812 5.63993 8.59897 4.96282 8.76067 4.368C8.92237 3.77319 9.15481 3.27077 9.45799 2.86075C9.76117 2.44784 10.1264 2.13311 10.5538 1.91655C10.984 1.69999 11.4648 1.59171 11.9961 1.59171C12.5533 1.59171 13.0471 1.70144 13.4773 1.92088C13.9104 2.14033 14.2598 2.44063 14.5255 2.82177C14.7911 3.20003 14.9557 3.62737 15.0192 4.1038H13.4383C13.3575 3.76308 13.1915 3.49166 12.9403 3.28954C12.6919 3.08453 12.3772 2.98202 11.9961 2.98202C11.381 2.98202 10.9075 3.24911 10.5754 3.78329C10.2463 4.31747 10.0802 5.05089 10.0773 5.98354H10.138C10.2795 5.72944 10.4628 5.51144 10.688 5.32953C10.9133 5.14762 11.1674 5.00758 11.4503 4.9094C11.7362 4.80834 12.0379 4.75781 12.3556 4.75781C12.8753 4.75781 13.3416 4.88197 13.7545 5.13029C14.1703 5.37861 14.4995 5.72078 14.742 6.15678C14.9846 6.5899 15.1044 7.08655 15.1015 7.64671C15.1044 8.22998 14.9716 8.75405 14.7031 9.21893C14.4345 9.68093 14.0606 10.0447 13.5813 10.3104C13.102 10.576 12.5432 10.7074 11.9051 10.7045ZM11.8964 9.40517C12.2112 9.40517 12.4927 9.32866 12.741 9.17562C12.9894 9.02258 13.1857 8.81613 13.3301 8.55626C13.4744 8.29639 13.5452 8.00476 13.5423 7.68136C13.5452 7.36374 13.4759 7.07644 13.3344 6.81946C13.1958 6.56247 13.0038 6.35891 12.7584 6.20876C12.5129 6.05861 12.2328 5.98354 11.9181 5.98354C11.6842 5.98354 11.4662 6.02829 11.2641 6.1178C11.062 6.20731 10.8858 6.33147 10.7357 6.49028C10.5855 6.64621 10.4672 6.82812 10.3805 7.03601C10.2968 7.24102 10.2535 7.46047 10.2506 7.69435C10.2535 8.00331 10.3257 8.28773 10.4672 8.5476C10.6086 8.80747 10.8035 9.01537 11.0519 9.17129C11.3002 9.32721 11.5817 9.40517 11.8964 9.40517Z"
      stroke="white"
      strokeWidth="1.19304"
      mask="url(#path-1-inside-1_10194_146)"
    />
    <path
      d="M19.8442 10.7522C19.131 10.7522 18.5188 10.5717 18.0077 10.2108C17.4996 9.84695 17.1083 9.32288 16.834 8.63855C16.5626 7.95134 16.4269 7.12408 16.4269 6.15678C16.4298 5.18949 16.5669 4.36656 16.8383 3.68801C17.1126 3.00657 17.5039 2.48682 18.0121 2.12878C18.5232 1.77074 19.1339 1.59171 19.8442 1.59171C20.5545 1.59171 21.1652 1.77074 21.6763 2.12878C22.1873 2.48682 22.5786 3.00657 22.85 3.68801C23.1243 4.36945 23.2615 5.19237 23.2615 6.15678C23.2615 7.12697 23.1243 7.95567 22.85 8.64288C22.5786 9.32721 22.1873 9.84984 21.6763 10.2108C21.1681 10.5717 20.5574 10.7522 19.8442 10.7522ZM19.8442 9.39651C20.3986 9.39651 20.836 9.12365 21.1565 8.57792C21.4799 8.0293 21.6416 7.22226 21.6416 6.15678C21.6416 5.45224 21.568 4.86032 21.4207 4.381C21.2735 3.90168 21.0656 3.54075 20.797 3.2982C20.5285 3.05277 20.2109 2.93005 19.8442 2.93005C19.2927 2.93005 18.8567 3.20436 18.5362 3.75297C18.2156 4.2987 18.0539 5.09997 18.0511 6.15678C18.0482 6.86421 18.1189 7.45903 18.2633 7.94123C18.4106 8.42344 18.6184 8.78726 18.887 9.03269C19.1555 9.27524 19.4746 9.39651 19.8442 9.39651Z"
      stroke="white"
      strokeWidth="1.19304"
      mask="url(#path-1-inside-1_10194_146)"
    />
    <path
      d="M26.2926 2.07504C26.2926 2.78203 25.7195 3.35516 25.0125 3.35516C24.3055 3.35516 23.7324 2.78203 23.7324 2.07504C23.7324 1.36805 24.3055 0.794922 25.0125 0.794922C25.7195 0.794922 26.2926 1.36805 26.2926 2.07504Z"
      stroke="white"
      strokeWidth="1.19304"
      mask="url(#path-1-inside-1_10194_146)"
    />
  </svg>
);

export const mapEntertainment = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clipPath="url(#clip0_4811_178942)">
      <path
        d="M13.9062 8.06934C11.7812 8.06934 9.71875 7.81934 7.90625 7.31934C7.78125 8.13184 7.65625 9.00684 7.65625 9.88184C7.65625 15.3818 10.4687 19.8193 13.9062 19.8193C17.3437 19.8193 20.1562 15.3818 20.1562 9.88184C20.1562 9.00684 20.0937 8.13184 19.9062 7.31934C18.0937 7.81934 16.0312 8.06934 13.9062 8.06934Z"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9062 15.5068C12.9687 15.5068 12.0937 15.2568 11.4062 14.8193C11.5312 16.1943 12.5937 17.3193 13.9062 17.3193C15.2187 17.3193 16.2812 16.1943 16.4062 14.8193C15.7187 15.2568 14.8437 15.5068 13.9062 15.5068Z"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1562 12.9443C10.1562 12.2568 10.7187 11.6943 11.4062 11.6943C12.0937 11.6943 12.6562 12.2568 12.6562 12.9443"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1562 12.9443C15.1562 12.2568 15.7187 11.6943 16.4062 11.6943C17.0937 11.6943 17.6562 12.2568 17.6562 12.9443"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2812 8.06934C13.7187 6.75684 13.9062 5.25684 13.9062 3.69434C13.9062 2.81934 13.8437 1.94434 13.6562 1.13184C11.7812 1.63184 9.78125 1.88184 7.65625 1.88184C5.53125 1.88184 3.46875 1.56934 1.65625 1.06934C1.46875 1.88184 1.40625 2.75684 1.40625 3.63184C1.40625 9.13184 4.21875 13.5693 7.65625 13.5693C7.78125 13.5693 7.96875 13.5693 8.09375 13.5693"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.65625 9.75684C6.71875 9.75684 5.84375 10.0068 5.15625 10.4443C5.28125 9.06934 6.34375 7.94434 7.65625 7.94434"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.90625 4.81934C3.90625 5.50684 4.46875 6.06934 5.15625 6.06934C5.84375 6.06934 6.40625 5.50684 6.40625 4.81934"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.90625 4.81934C8.90625 5.50684 9.46875 6.06934 10.1562 6.06934C10.8437 6.06934 11.4062 5.50684 11.4062 4.81934"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4811_178942">
        <rect width="20" height="20" transform="translate(0.78125 0.444336)" />
      </clipPath>
    </defs>
  </svg>
);

export const mapBanks = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M4.94792 7.50018V14.1668M8.69792 7.50018V14.1668M12.8646 7.50018V14.1668M16.6146 7.50018V14.1668M3.28125 15.5002V16.1668C3.28125 16.6336 3.28125 16.8669 3.37207 17.0452C3.45197 17.202 3.57946 17.3295 3.73626 17.4093C3.91452 17.5002 4.14787 17.5002 4.61458 17.5002H16.9479C17.4147 17.5002 17.648 17.5002 17.8263 17.4093C17.9831 17.3295 18.1105 17.202 18.1904 17.0452C18.2813 16.8669 18.2812 16.6336 18.2812 16.1668V15.5002C18.2812 15.0335 18.2813 14.8001 18.1904 14.6218C18.1105 14.4651 17.9831 14.3376 17.8263 14.2577C17.648 14.1668 17.4147 14.1668 16.9479 14.1668H4.61458C4.14787 14.1668 3.91452 14.1668 3.73626 14.2577C3.57946 14.3376 3.45197 14.4651 3.37207 14.6218C3.28125 14.8001 3.28125 15.0335 3.28125 15.5002ZM10.492 2.56445L4.32534 3.93483C3.95279 4.01761 3.76652 4.05901 3.62747 4.15918C3.50483 4.24754 3.40853 4.3676 3.34888 4.50649C3.28125 4.66395 3.28125 4.85477 3.28125 5.2364V6.16685C3.28125 6.63355 3.28125 6.86691 3.37207 7.04517C3.45197 7.20197 3.57946 7.32945 3.73626 7.40935C3.91452 7.50018 4.14787 7.50018 4.61458 7.50018H16.9479C17.4147 7.50018 17.648 7.50018 17.8263 7.40935C17.9831 7.32945 18.1105 7.20197 18.1904 7.04517C18.2813 6.86691 18.2812 6.63355 18.2812 6.16685V5.23641C18.2812 4.85477 18.2812 4.66395 18.2136 4.50649C18.154 4.3676 18.0577 4.24754 17.935 4.15918C17.796 4.05901 17.6098 4.01761 17.2372 3.93483L11.0705 2.56445C10.9626 2.54047 10.9086 2.52848 10.8541 2.5237C10.8056 2.51945 10.7569 2.51945 10.7084 2.5237C10.6539 2.52848 10.5999 2.54047 10.492 2.56445Z"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mapAllLayers = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
    <path
      d="M10.8523 3.05566L3.72266 3.05566L3.72266 10.1853H10.8523V3.05566Z"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.056 3.05566L14.9264 3.05566V10.1853L22.056 10.1853V3.05566Z"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.056 14.2594H14.9264V21.389L22.056 21.389L22.056 14.2594Z"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8523 14.2594H3.72266L3.72266 21.389H10.8523L10.8523 14.2594Z"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const collapseArrow = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M19.2222 16.1668L13.1111 10.0557L7 16.1668"
      stroke="#101828"
      strokeWidth="1.62963"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const dotIcon = (
  <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.5" cy="2" r="2" fill="currentColor" />
  </svg>
);

export const clusterIcon = (count: number) => `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="40" height="40">
    <circle r="100" cx="100" cy="100" fill="white" />
    <circle r="80" cx="100" cy="100" fill="#0494fe" />
    <text x="50%" y="55%" style="fill:#fff" text-anchor="middle" font-size="110" dominant-baseline="middle" class="heavy">${count}</text>
  </svg>
`;

export const timelineLine = (
  <svg width="102" height="5" viewBox="0 0 102 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 2.97656L101 2" stroke="currentColor" strokeWidth="4" />
  </svg>
);

export const timelineDashedLine = (
  <svg width="304" height="5" viewBox="0 0 304 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 2.97656H304" stroke="currentColor" strokeWidth="4" strokeDasharray="8 8" />
  </svg>
);

export const timelineCircle = (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.5" cy="15.9766" r="13" fill="white" stroke="currentColor" strokeWidth="4" />
  </svg>
);

export const starAvatar = (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="1.47656" width="39" height="39" rx="7.5" fill="white" />
    <rect x="0.5" y="1.47656" width="39" height="39" rx="7.5" stroke="#EAECF0" />
    <path
      d="M20 10.9766L23.09 17.2366L30 18.2466L25 23.1166L26.18 29.9966L20 26.7466L13.82 29.9966L15 23.1166L10 18.2466L16.91 17.2366L20 10.9766Z"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const starLeadForm = (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M10.4974 1.66406L13.0724 6.88073L18.8307 7.7224L14.6641 11.7807L15.6474 17.5141L10.4974 14.8057L5.3474 17.5141L6.33073 11.7807L2.16406 7.7224L7.9224 6.88073L10.4974 1.66406Z"
      fill="#0494FE"
      stroke="#0494FE"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const featherAvatar = (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="1.47656" width="39" height="39" rx="7.5" fill="white" />
    <rect x="0.5" y="1.47656" width="39" height="39" rx="7.5" stroke="#EAECF0" />
    <path
      d="M24 16.9771L10 30.9771M25.5 23.9771H17M28.24 21.2171C29.3658 20.0912 29.9983 18.5643 29.9983 16.9721C29.9983 15.3799 29.3658 13.8529 28.24 12.7271C27.1142 11.6012 25.5872 10.9688 23.995 10.9688C22.4028 10.9688 20.8758 11.6012 19.75 12.7271L13 19.4771V27.9771H21.5L28.24 21.2171Z"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const fileIcon = (
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 0.976562H3C2.46957 0.976563 1.96086 1.18728 1.58579 1.56235C1.21071 1.93742 1 2.44613 1 2.97656V18.9766C1 19.507 1.21071 20.0157 1.58579 20.3908C1.96086 20.7658 2.46957 20.9766 3 20.9766H15C15.5304 20.9766 16.0391 20.7658 16.4142 20.3908C16.7893 20.0157 17 19.507 17 18.9766V6.97656M11 0.976562L17 6.97656M11 0.976562V6.97656H17M13 11.9766H5M13 15.9766H5M7 7.97656H5"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowBoxedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const lineIcon = (
  <svg viewBox="0 0 100 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M-674 2L419 2.0001" stroke="currentColor" strokeWidth="4" />
  </svg>
);

export const circleIcon = (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.5" cy="15" r="13" fill="white" stroke="currentColor" strokeWidth="4" />
  </svg>
);

export const successIcon = (
  <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4.5" y="4.96094" width="48" height="48" rx="24" fill="#D1FADF" />
    <rect x="4.5" y="4.96094" width="48" height="48" rx="24" stroke="#ECFDF3" strokeWidth="8" />
    <path
      d="M38.5 28.0388V28.9588C38.4988 31.1153 37.8005 33.2135 36.5093 34.9407C35.2182 36.6678 33.4033 37.9313 31.3354 38.5427C29.2674 39.1542 27.0573 39.0807 25.0345 38.3334C23.0117 37.5861 21.2847 36.2049 20.111 34.3959C18.9373 32.5869 18.3798 30.4469 18.5217 28.2952C18.6636 26.1434 19.4972 24.0952 20.8983 22.4559C22.2994 20.8167 24.1928 19.6742 26.2962 19.199C28.3996 18.7238 30.6003 18.9412 32.57 19.8188M38.5 20.9588L28.5 30.9688L25.5 27.9688"
      stroke="#039855"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const phoneIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3626_170719)">
      <path
        d="M16.4942 12.6901V14.9401C16.4951 15.1489 16.4523 15.3557 16.3686 15.5471C16.2849 15.7385 16.1622 15.9103 16.0083 16.0515C15.8544 16.1927 15.6726 16.3002 15.4748 16.3671C15.2769 16.434 15.0672 16.4589 14.8592 16.4401C12.5513 16.1893 10.3345 15.4007 8.38671 14.1376C6.57458 12.9861 5.03821 11.4497 3.88671 9.63757C2.6192 7.68098 1.83039 5.45332 1.58421 3.13507C1.56547 2.92767 1.59012 2.71864 1.65659 2.52129C1.72306 2.32394 1.82989 2.14259 1.97029 1.98879C2.11068 1.83499 2.28157 1.7121 2.47206 1.62796C2.66255 1.54382 2.86847 1.50027 3.07671 1.50007H5.32671C5.69069 1.49649 6.04356 1.62538 6.31953 1.86272C6.59551 2.10006 6.77577 2.42966 6.82671 2.79007C6.92168 3.51012 7.0978 4.21712 7.35171 4.89757C7.45262 5.16602 7.47446 5.45776 7.41464 5.73823C7.35483 6.01871 7.21586 6.27616 7.01421 6.48007L6.06171 7.43257C7.12938 9.31023 8.68405 10.8649 10.5617 11.9326L11.5142 10.9801C11.7181 10.7784 11.9756 10.6395 12.2561 10.5796C12.5365 10.5198 12.8283 10.5417 13.0967 10.6426C13.7772 10.8965 14.4842 11.0726 15.2042 11.1676C15.5685 11.219 15.9013 11.4025 16.1391 11.6832C16.377 11.9639 16.5033 12.3223 16.4942 12.6901Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3626_170719">
        <rect width="18" height="18" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const roomIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 21.0001L14 21V5.98924C14 4.6252 14 3.94318 13.7187 3.47045C13.472 3.05596 13.0838 2.74457 12.6257 2.59368C12.1032 2.42159 11.4374 2.56954 10.1058 2.86544L7.50582 3.44322C6.6117 3.64191 6.16464 3.74126 5.83093 3.98167C5.53658 4.19373 5.30545 4.48186 5.1623 4.8152C5 5.19312 5 5.65108 5 6.56702V21.0001M13.994 5.00007H15.8C16.9201 5.00007 17.4802 5.00007 17.908 5.21805C18.2843 5.4098 18.5903 5.71576 18.782 6.09209C19 6.51991 19 7.07996 19 8.20007V21.0001H21M11 12.0001H11.01"
      stroke="black"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const coinsIcon = (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.23865 4.36664C10.6748 1.9294 14.6258 1.93034 17.0628 4.36664C19.4999 6.80293 19.4999 10.7543 17.0628 13.1915M14.4338 13.2357C14.4338 16.6824 11.6399 19.4766 8.19348 19.4766C4.74703 19.4766 1.95312 16.6824 1.95312 13.2357C1.95312 9.78902 4.74703 6.9949 8.19348 6.9949C11.6399 6.9949 14.4338 9.78902 14.4338 13.2357Z"
      stroke="#101828"
      strokeWidth="1.355"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const squareMeterIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0001 22H6.80006C5.1199 22 4.27982 22 3.63809 21.673C3.0736 21.3854 2.61466 20.9265 2.32704 20.362C2.00006 19.7202 2.00006 18.8802 2.00006 17.2V10M10.0001 2H14.0001M22.0001 10V14M18.0001 22C18.9301 22 19.3951 22 19.7766 21.8978C20.8118 21.6204 21.6205 20.8117 21.8979 19.7765C22.0001 19.395 22.0001 18.93 22.0001 18M22.0001 6C22.0001 5.07003 22.0001 4.60504 21.8979 4.22354C21.6205 3.18827 20.8118 2.37962 19.7766 2.10222C19.3951 2 18.9301 2 18.0001 2M6.00006 2C5.07009 2 4.6051 2 4.2236 2.10222C3.18833 2.37962 2.37968 3.18827 2.10228 4.22354C2.00006 4.60504 2.00006 5.07003 2.00006 6"
      stroke="black"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 14.9364V9.56149H8.21076V10.4748H8.27375C8.38573 10.1669 8.57119 9.92659 8.83014 9.75395C9.08909 9.57899 9.39819 9.49151 9.75745 9.49151C10.1214 9.49151 10.4282 9.58016 10.6778 9.75745C10.9297 9.93242 11.107 10.1715 11.2097 10.4748H11.2657C11.3846 10.1762 11.5853 9.93825 11.8675 9.76095C12.1521 9.58132 12.4892 9.49151 12.8788 9.49151C13.3734 9.49151 13.777 9.64781 14.0896 9.96041C14.4022 10.273 14.5585 10.7291 14.5585 11.3286V14.9364H13.2883V11.5246C13.2883 11.191 13.1996 10.9472 13.0223 10.7932C12.845 10.6369 12.6281 10.5588 12.3714 10.5588C12.0658 10.5588 11.8267 10.6544 11.6541 10.8457C11.4838 11.0347 11.3986 11.2808 11.3986 11.5841V14.9364H10.1564V11.4721C10.1564 11.1945 10.0724 10.9729 9.90443 10.8072C9.73879 10.6416 9.52183 10.5588 9.25355 10.5588C9.07159 10.5588 8.90596 10.6055 8.75665 10.6988C8.60735 10.7898 8.48837 10.9192 8.39972 11.0872C8.31107 11.2528 8.26675 11.4465 8.26675 11.6681V14.9364H7Z"
      fill="black"
    />
    <path
      d="M15.6442 11.3531V10.6568L17.3273 9.26055C17.4673 9.14391 17.5874 9.03776 17.6878 8.94212C17.7881 8.84414 17.8651 8.74849 17.9187 8.65517C17.9724 8.55952 17.9992 8.45571 17.9992 8.34373C17.9992 8.16177 17.9269 8.01946 17.7822 7.91682C17.6376 7.81417 17.4603 7.76285 17.2503 7.76285C17.0264 7.76285 16.8456 7.82 16.708 7.93431C16.5726 8.04629 16.505 8.2026 16.505 8.40322H15.5777C15.5777 7.96931 15.7351 7.62754 16.0501 7.37792C16.3674 7.12597 16.7721 7 17.2643 7C17.5979 7 17.8884 7.05949 18.1357 7.17846C18.3853 7.29511 18.5789 7.45374 18.7166 7.65437C18.8542 7.855 18.923 8.08012 18.923 8.32974C18.923 8.53036 18.8822 8.71699 18.8005 8.88963C18.7189 9.05993 18.5917 9.23139 18.4191 9.40402C18.2465 9.57432 18.026 9.75862 17.7577 9.95691L17.0369 10.5308V10.5623H19V11.3531H15.6442Z"
      fill="black"
    />
  </svg>
);

export const floorIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 14.5L12 19.5L22 14.5M12 4.5L2 9.5L12 14.5L22 9.5L12 4.5Z"
      stroke="#101828"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MobileNavCloseIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16.002 1.6107L14.3905 -0.000732422L8.00195 6.38784L1.61338 -0.000732422L0.00195312 1.6107L6.39052 7.99927L0.00195312 14.3878L1.61338 15.9993L8.00195 9.6107L14.3905 15.9993L16.002 14.3878L9.61338 7.99927L16.002 1.6107Z"
      fill="currentColor"
    />
  </svg>
);

export const MobileNavIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M3.31836 10.0371L17.4541 10.0371M3.31836 5.3252L17.4541 5.3252M3.31836 14.749L17.4541 14.749"
      stroke="black"
      strokeWidth="1.50781"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const playIconWithBackground = (
  <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.75 60C47.3185 60 60.75 46.5685 60.75 30C60.75 13.4315 47.3185 0 30.75 0C14.1815 0 0.75 13.4315 0.75 30C0.75 46.5685 14.1815 60 30.75 60ZM26.0625 41.0041L42.9375 31.572C44.1875 30.8733 44.1875 29.1267 42.9375 28.428L26.0625 18.9959C24.8125 18.2972 23.25 19.1706 23.25 20.5679V39.4321C23.25 40.8294 24.8125 41.7028 26.0625 41.0041Z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);

export const shareIcon = (
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.83414 14.5679L15.7906 18.6216M15.7804 7.43825L8.83414 11.4919M21.474 5.90028C21.474 7.58782 20.1059 8.95584 18.4184 8.95584C16.7309 8.95584 15.3628 7.58782 15.3628 5.90028C15.3628 4.21275 16.7309 2.84473 18.4184 2.84473C20.1059 2.84473 21.474 4.21275 21.474 5.90028ZM9.25174 13.0299C9.25174 14.7174 7.88372 16.0855 6.19618 16.0855C4.50864 16.0855 3.14063 14.7174 3.14063 13.0299C3.14063 11.3424 4.50864 9.97436 6.19618 9.97436C7.88372 9.97436 9.25174 11.3424 9.25174 13.0299ZM21.474 20.1595C21.474 21.8471 20.1059 23.2151 18.4184 23.2151C16.7309 23.2151 15.3628 21.8471 15.3628 20.1595C15.3628 18.472 16.7309 17.104 18.4184 17.104C20.1059 17.104 21.474 18.472 21.474 20.1595Z"
      stroke="currentColor"
      strokeWidth="1.95556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronUpIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.1675 15.5L12.1675 9.5L6.16748 15.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronDownIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.16846 9.50195L12.1685 15.502L18.1685 9.50195"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const closeIcon = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 5.5L5 15.5M5 5.5L15 15.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowUpIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 19V5M12 5L5 12M12 5L19 12"
      stroke="black"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowDownIcon = (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.50016 3.73535V13.0687M8.50016 13.0687L13.1668 8.40202M8.50016 13.0687L3.8335 8.40202"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const minusIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z" />
  </svg>
);

export const filtersIconSmall = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 10.5H15M2.5 5.5H17.5M7.5 15.5H12.5"
      stroke="#101828"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const playIcon = (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <path
      d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
      fill="currentColor"
    />
  </svg>
);

export const overlayPlayIcon = (
  <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1953 8.10176C17.1953 8.6607 17.1953 10.058 16.1953 10.617L2.69531 18.1627C1.69531 18.7216 0.445312 18.0229 0.445313 16.905L0.445313 1.8137C0.445313 0.695828 1.69531 -0.00284356 2.69531 0.556095L16.1953 8.10176Z"
      fill="currentColor"
    />
  </svg>
);

export const expandIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.88889 1H2.55556C2.143 1 1.74733 1.16389 1.45561 1.45561C1.16389 1.74733 1 2.143 1 2.55556V4.88889M15 4.88889V2.55556C15 2.143 14.8361 1.74733 14.5444 1.45561C14.2527 1.16389 13.857 1 13.4444 1H11.1111M11.1111 15H13.4444C13.857 15 14.2527 14.8361 14.5444 14.5444C14.8361 14.2527 15 13.857 15 13.4444V11.1111M1 11.1111V13.4444C1 13.857 1.16389 14.2527 1.45561 14.5444C1.74733 14.8361 2.143 15 2.55556 15H4.88889"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const iosSpinIcon = (
  <svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="28.5078"
      y="14"
      width="6"
      height="14"
      rx="3"
      transform="rotate(180 28.5078 14)"
      fill="white"
    />
    <rect
      x="35.75"
      y="19.1426"
      width="6"
      height="14"
      rx="3"
      transform="rotate(-135 35.75 19.1426)"
      fill="white"
      fill-opacity="0.41"
    />
    <rect
      x="37.2344"
      y="27.8984"
      width="6"
      height="14"
      rx="3"
      transform="rotate(-90 37.2344 27.8984)"
      fill="white"
      fill-opacity="0.41"
    />
    <rect
      x="32.0938"
      y="35.1406"
      width="6"
      height="14"
      rx="3"
      transform="rotate(-45 32.0938 35.1406)"
      fill="white"
      fill-opacity="0.41"
    />
    <rect x="23.3359" y="36.625" width="6" height="14" rx="3" fill="white" fill-opacity="0.41" />
    <rect
      x="16.0938"
      y="31.4834"
      width="6"
      height="14"
      rx="3"
      transform="rotate(45 16.0938 31.4834)"
      fill="white"
      fill-opacity="0.41"
    />
    <rect
      x="14.6094"
      y="22.7266"
      width="6"
      height="14"
      rx="3"
      transform="rotate(90 14.6094 22.7266)"
      fill="white"
      fill-opacity="0.57"
    />
    <rect
      x="19.7539"
      y="15.4844"
      width="6"
      height="14"
      rx="3"
      transform="rotate(135 19.7539 15.4844)"
      fill="white"
      fill-opacity="0.8"
    />
  </svg>
);

export const sortArrow = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17 16" fill="none">
    <path
      d="M8.94596 3.33203V12.6654M8.94596 12.6654L13.6126 7.9987M8.94596 12.6654L4.2793 7.9987"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const whatsappIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z"
      fill="#BFC8D0"
    />
    <path
      d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
      fill="url(#paint0_linear_1334_774)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z"
      fill="white"
    />
    <path
      d="M12.5 9.50001C12.1672 8.83143 11.6565 8.89062 11.1407 8.89062C10.2188 8.89062 8.78125 9.9949 8.78125 12.0501C8.78125 13.7344 9.52345 15.5782 12.0244 18.3362C14.438 20.998 17.6094 22.3749 20.2422 22.3281C22.875 22.2812 23.4167 20.0156 23.4167 19.2504C23.4167 18.9113 23.2062 18.7421 23.0613 18.6961C22.1641 18.2656 20.5093 17.4633 20.1328 17.3125C19.7563 17.1618 19.5597 17.3657 19.4375 17.4766C19.0961 17.802 18.4193 18.7609 18.1875 18.9766C17.9558 19.1923 17.6103 19.0831 17.4665 19.0016C16.9374 18.7893 15.5029 18.1512 14.3595 17.0427C12.9453 15.6719 12.8623 15.2003 12.5959 14.7804C12.3828 14.4446 12.5392 14.2385 12.6172 14.1484C12.9219 13.7969 13.3426 13.2541 13.5313 12.9844C13.7199 12.7147 13.5702 12.3051 13.4803 12.0501C13.0938 10.9531 12.7663 10.0349 12.5 9.50001Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_774"
        x1="26.5"
        y1="7"
        x2="4"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5BD066" />
        <stop offset="1" stopColor="#27B43E" />
      </linearGradient>
    </defs>
  </svg>
);

export const facebookIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_1334_718)" />
    <path
      d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_718"
        x1="16"
        y1="2"
        x2="16"
        y2="29.917"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18ACFE" />
        <stop offset="1" stopColor="#0163E0" />
      </linearGradient>
    </defs>
  </svg>
);

export const linkedinIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="28" height="28" rx="14" fill="#1275B1" />
    <path
      d="M12.6186 9.69215C12.6186 10.6267 11.8085 11.3843 10.8093 11.3843C9.81004 11.3843 9 10.6267 9 9.69215C9 8.7576 9.81004 8 10.8093 8C11.8085 8 12.6186 8.7576 12.6186 9.69215Z"
      fill="white"
    />
    <path d="M9.24742 12.6281H12.3402V22H9.24742V12.6281Z" fill="white" />
    <path
      d="M17.3196 12.6281H14.2268V22H17.3196C17.3196 22 17.3196 19.0496 17.3196 17.2049C17.3196 16.0976 17.6977 14.9855 19.2062 14.9855C20.911 14.9855 20.9008 16.4345 20.8928 17.5571C20.8824 19.0244 20.9072 20.5219 20.9072 22H24V17.0537C23.9738 13.8954 23.1508 12.4401 20.4433 12.4401C18.8354 12.4401 17.8387 13.1701 17.3196 13.8305V12.6281Z"
      fill="white"
    />
  </svg>
);

export const bicycleIcon = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.6372 9.39011C18.5935 9.39011 18.5515 9.39573 18.5087 9.39685L17.7792 5.13162C17.7397 4.90156 17.6027 4.69973 17.4044 4.57698C17.2065 4.45433 16.9649 4.42293 16.741 4.49043L14.5442 5.15579C14.1147 5.28606 13.8719 5.74013 14.0021 6.17035C14.1324 6.60024 14.5879 6.84387 15.016 6.71307L16.33 6.31498L16.6312 8.07091H9.71501V7.72528L10.5651 7.51071C10.9029 7.42567 11.1436 7.11067 11.1235 6.74995C11.1008 6.34116 10.7504 6.02851 10.3411 6.05195L7.20111 6.23038C7.13849 6.23429 7.06918 6.24465 7.00568 6.26047C6.44812 6.40158 6.10942 6.96809 6.2502 7.52585C6.39097 8.08361 6.9582 8.42161 7.51582 8.28089L8.08764 8.13636V8.66462L7.41876 9.81667C6.78554 9.54265 6.09301 9.39011 5.36571 9.39011C2.40718 9.39011 0 11.8919 0 14.9671C0 18.0427 2.40718 20.5445 5.36571 20.5445C8.05614 20.5445 10.2848 18.4709 10.6651 15.7807H11.5327C11.7639 15.7807 11.984 15.6822 12.1382 15.5097L13.3316 14.1769C13.2958 14.436 13.2711 14.6982 13.2711 14.9671C13.2711 18.0427 15.6787 20.5445 18.6372 20.5445C21.5944 20.5445 24 18.0427 24 14.9671C24 11.8919 21.5944 9.39011 18.6372 9.39011ZM5.36571 18.9174C3.30431 18.9174 1.62693 17.1453 1.62693 14.9671C1.62693 12.789 3.30431 11.0173 5.36571 11.0173C5.79472 11.0173 6.20018 11.1098 6.58469 11.2512L4.66191 14.5584C4.51566 14.8099 4.51483 15.1205 4.6602 15.3728C4.80473 15.6251 5.07411 15.7807 5.36571 15.7807H9.02048C8.6646 17.5695 7.16164 18.9174 5.36571 18.9174ZM9.02048 14.1535H6.78007L7.95615 12.131C8.48348 12.6698 8.86418 13.3669 9.02048 14.1535ZM11.1689 14.1535H10.6651C10.4697 12.7672 9.78647 11.5436 8.79653 10.6846L9.37012 9.69788H15.1565L11.1689 14.1535ZM18.6372 18.9174C16.5754 18.9174 14.8984 17.1453 14.8984 14.9671C14.8984 13.3317 15.8438 11.9254 17.188 11.3264L17.8346 15.1046C17.9032 15.5011 18.2465 15.7807 18.6356 15.7807C18.6817 15.7807 18.728 15.7772 18.7737 15.7692C19.2175 15.6933 19.5145 15.2726 19.4389 14.8298L18.7889 11.0335C20.7776 11.1202 22.3731 12.8442 22.3731 14.9671C22.3731 17.1452 20.6965 18.9174 18.6372 18.9174Z"
      fill="currentColor"
    />
  </svg>
);

export const carIcon = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 8.5L5.72187 10.7682C5.90158 10.918 6.12811 11 6.36205 11H17.6379C17.8719 11 18.0984 10.918 18.2781 10.7682L21 8.5M6.5 14.5H6.51M17.5 14.5H17.51M8.16065 5H15.8394C16.5571 5 17.2198 5.38457 17.5758 6.00772L20.473 11.0777C20.8183 11.6821 21 12.3661 21 13.0623V19C21 19.5523 20.5523 20 20 20H19C18.4477 20 18 19.5523 18 19V18H6V19C6 19.5523 5.55228 20 5 20H4C3.44772 20 3 19.5523 3 19V13.0623C3 12.3661 3.18166 11.6821 3.52703 11.0777L6.42416 6.00772C6.78024 5.38457 7.44293 5 8.16065 5ZM7 14.5C7 14.7761 6.77614 15 6.5 15C6.22386 15 6 14.7761 6 14.5C6 14.2239 6.22386 14 6.5 14C6.77614 14 7 14.2239 7 14.5ZM18 14.5C18 14.7761 17.7761 15 17.5 15C17.2239 15 17 14.7761 17 14.5C17 14.2239 17.2239 14 17.5 14C17.7761 14 18 14.2239 18 14.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const walkingPersonIcon = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6.49994C14.1046 6.49994 15 5.60451 15 4.49994C15 3.39537 14.1046 2.49994 13 2.49994C11.8955 2.49994 11 3.39537 11 4.49994C11 5.60451 11.8955 6.49994 13 6.49994ZM11.0528 7.10551C11.3841 6.93986 11.7799 6.97091 12.0813 7.18621L13.0813 7.9005C13.3994 8.12774 13.5559 8.51953 13.482 8.90342L12.4332 14.3469L16.8321 20.9452C17.1384 21.4047 17.0143 22.0256 16.5547 22.332C16.0952 22.6383 15.4743 22.5141 15.168 22.0546L10.5416 15.1151L9.72613 13.8918C9.58338 13.6777 9.52868 13.4168 9.5734 13.1633L10.1699 9.78303L8.38466 10.6756L7.81284 13.5333C7.70447 14.0749 7.17761 14.426 6.63606 14.3177C6.09451 14.2093 5.74335 13.6824 5.85171 13.1409L6.51949 9.80373C6.58003 9.50117 6.77686 9.2435 7.05284 9.10551L11.0528 7.10551ZM16.6838 13.4486L13.8093 12.4904L14.1909 10.5095L17.3163 11.5512C17.8402 11.7259 18.1234 12.2922 17.9487 12.8161C17.7741 13.3401 17.2078 13.6233 16.6838 13.4486ZM6.12846 21.0096L9.39639 15.2L9.7096 15.6698L10.641 17.0668L7.87161 21.9902C7.60085 22.4715 6.99113 22.6422 6.50978 22.3715C6.02842 22.1007 5.8577 21.491 6.12846 21.0096Z"
      fill="currentColor"
    />
  </svg>
);

export const maximizeIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0888 7.20007H9.15551C8.63686 7.20007 8.13946 7.4061 7.77272 7.77284C7.40598 8.13958 7.19995 8.63698 7.19995 9.15563V12.089M24.8 12.089V9.15563C24.8 8.63698 24.5939 8.13958 24.2272 7.77284C23.8604 7.4061 23.363 7.20007 22.8444 7.20007H19.9111M19.9111 24.8001H22.8444C23.363 24.8001 23.8604 24.594 24.2272 24.2273C24.5939 23.8606 24.8 23.3632 24.8 22.8445V19.9112M7.19995 19.9112V22.8445C7.19995 23.3632 7.40598 23.8606 7.77272 24.2273C8.13946 24.594 8.63686 24.8001 9.15551 24.8001H12.0888"
      stroke="black"
      strokeWidth="2.01143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const zoomInIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z" />
  </svg>
);

export const zoomOutIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" />
  </svg>
);

export const zoomResetIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z" />
  </svg>
);

export const memoIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_10191_229953)">
      <path
        d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10191_229953">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const copyIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M4.16797 12.7567H3.33464C2.89261 12.7567 2.46868 12.5811 2.15612 12.2685C1.84356 11.956 1.66797 11.532 1.66797 11.09V3.59001C1.66797 3.14798 1.84356 2.72406 2.15612 2.4115C2.46868 2.09893 2.89261 1.92334 3.33464 1.92334H10.8346C11.2767 1.92334 11.7006 2.09893 12.0131 2.4115C12.3257 2.72406 12.5013 3.14798 12.5013 3.59001V4.42334M9.16797 7.75667H16.668C17.5884 7.75667 18.3346 8.50287 18.3346 9.42334V16.9233C18.3346 17.8438 17.5884 18.59 16.668 18.59H9.16797C8.24749 18.59 7.5013 17.8438 7.5013 16.9233V9.42334C7.5013 8.50287 8.24749 7.75667 9.16797 7.75667Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
